/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * MailCraft API — email automation, templates, AI generation, send logs.
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminBulkDeleteInput,
  AdminBulkDeleteUsers200,
  AdminCreateUserInput,
  AdminGetEmailVolumeCsvParams,
  AdminGetEmailVolumeForUserParams,
  AdminGetEmailVolumeParams,
  AdminListAuditLogParams,
  AdminListRateLimitAlertsParams,
  AdminListTrashedTemplatesParams,
  AdminListUsersParams,
  AdminMergeInput,
  AdminMergeUsers200,
  AdminTrashedTemplateList,
  AdminUpdateUserInput,
  AdminUser,
  AdminUserList,
  AiFollowUpInput,
  AiFollowUpResponse,
  AiGenerateInput,
  AiGeneratedDraft,
  AiRateLimitError,
  AiReplyDraft,
  AiReplyDraftInput,
  AiSpamCheckInput,
  AiSpamReport,
  AiSubjectsInput,
  AiSubjectsResponse,
  AiToneInput,
  AiToneResponse,
  ApiKeyEnvelope,
  ApiKeyList,
  AuditLogList,
  BadRequestResponse,
  BrandSettings,
  BulkDeleteTemplatesInput,
  BulkDeleteTemplatesResult,
  BulkImportContactsInput,
  ClientPreviewProfile,
  ConflictResponse,
  Contact,
  ContactImportSummary,
  ContactValidationError,
  CreateApiKeyInput,
  CreateApiKeyResult,
  CreateContactInput,
  CreateContactResponse,
  CreateInboundMailboxInput,
  CreateSnippetInput,
  CreateTemplateInput,
  CreateTrustedSenderInput,
  CreateWebhookEndpointInput,
  CreateWebhookEndpointResult,
  DashboardSummary,
  EmailLog,
  EmailLogDetail,
  EmailVolumeAgentDetail,
  EmailVolumeReport,
  EngagementEventList,
  ErrorResponse,
  ExportEngagementEventsCsvParams,
  ForbiddenResponse,
  GetInboundVerificationStatsByMailbox200,
  GetInboundVerificationStatsByMailboxParams,
  GetInboundVerificationStatsParams,
  GmailArchiveResult,
  GmailCreateLabelInput,
  GmailLabel,
  GmailLabelList,
  GmailLabelsMutation,
  GmailLabelsMutationResult,
  GmailMessageDetail,
  GmailMessageList,
  GmailReadStateInput,
  GmailReadStateResult,
  GmailReplyInput,
  GmailSendResult,
  GmailStatus,
  GmailUnavailableError,
  GmailWatchResult,
  HealthStatus,
  InboundEmailDetail,
  InboundEmailListItem,
  InboundMailbox,
  InboundMailboxList,
  InboundVerificationStats,
  ListEmailLogsParams,
  ListEngagementEventsParams,
  ListGmailMessagesParams,
  ListInboundEmailsParams,
  ListInboundMailboxesParams,
  ListTemplatesParams,
  NextCaseReference,
  NotFoundResponse,
  PreviewTemplateForClientInput,
  PubsubMetricsResponse,
  RateLimitAlertList,
  RenderTemplateInput,
  RenderedClientPreview,
  RenderedEmail,
  RepDefaults,
  ReplyDraft,
  SaveReplyDraftInput,
  SearchEmailsParams,
  SearchResults,
  SendEmailInput,
  SendEmailResponse,
  SendValidationError,
  SenderAddress,
  SenderConfig,
  SenderDnsRecords,
  SenderRefreshRateLimitError,
  SetInboundEmailReadState200,
  SetInboundEmailReadStateInput,
  SetThreadStateInput,
  SnippetDeleteConflict,
  SnippetUsage,
  StopGmailWatch200,
  Template,
  TemplateAutoDefaults,
  TemplateEngagement,
  TemplateSnippet,
  TemplateSnippetWithUsage,
  TestInboundWebhookInput,
  TestInboundWebhookResult,
  ThreadUserState,
  TrustedSender,
  TrustedSenderList,
  UnauthorizedResponse,
  UpdateBrandSettings403,
  UpdateBrandSettingsInput,
  UpdateContactInput,
  UpdateInboundMailboxInput,
  UpdateMePreferencesInput,
  UpdateRepDefaultsInput,
  UpdateSnippetInput,
  UpdateTemplateInput,
  UpdateWebhookEndpointInput,
  User,
  WebhookDeliveryList,
  WebhookEndpointEnvelope,
  WebhookEndpointList,
  WebhookRedeliverResult,
  WebhookTestResult,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Bypasses the in-memory sender-verification cache, re-queries Resend's verified-domain list, and updates the cache with the result. Intended for users who just verified their domain in the Resend dashboard and don't want to wait for the next background refresh. Per-user rate-limited to avoid hammering Resend.

 * @summary Force a fresh re-classification of the configured sender
 */
export const getRefreshSenderConfigUrl = () => {
  return `/api/healthz/sender/refresh`;
};

export const refreshSenderConfig = async (
  options?: RequestInit,
): Promise<SenderConfig> => {
  return customFetch<SenderConfig>(getRefreshSenderConfigUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshSenderConfigMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | SenderRefreshRateLimitError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSenderConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshSenderConfig>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["refreshSenderConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshSenderConfig>>,
    void
  > = () => {
    return refreshSenderConfig(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshSenderConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshSenderConfig>>
>;

export type RefreshSenderConfigMutationError = ErrorType<
  UnauthorizedResponse | SenderRefreshRateLimitError
>;

/**
 * @summary Force a fresh re-classification of the configured sender
 */
export const useRefreshSenderConfig = <
  TError = ErrorType<UnauthorizedResponse | SenderRefreshRateLimitError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshSenderConfig>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshSenderConfig>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshSenderConfigMutationOptions(options));
};

/**
 * Returns in-process, historical (flushed to DB), and combined totals for JWT vs shared-token Pub/Sub authentication events.

 * @summary Pub/Sub authentication metrics
 */
export const getGetPubsubMetricsUrl = () => {
  return `/api/healthz/pubsub-metrics`;
};

export const getPubsubMetrics = async (
  options?: RequestInit,
): Promise<PubsubMetricsResponse> => {
  return customFetch<PubsubMetricsResponse>(getGetPubsubMetricsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPubsubMetricsQueryKey = () => {
  return [`/api/healthz/pubsub-metrics`] as const;
};

export const getGetPubsubMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPubsubMetrics>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPubsubMetrics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPubsubMetricsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPubsubMetrics>>
  > = ({ signal }) => getPubsubMetrics({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPubsubMetrics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPubsubMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPubsubMetrics>>
>;
export type GetPubsubMetricsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Pub/Sub authentication metrics
 */

export function useGetPubsubMetrics<
  TData = Awaited<ReturnType<typeof getPubsubMetrics>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPubsubMetrics>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPubsubMetricsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get current user profile (auto-created on first call)
 */
export const getGetMeUrl = () => {
  return `/api/me`;
};

export const getMe = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get current user profile (auto-created on first call)
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Counts and recent activity for the dashboard
 */
export const getGetDashboardSummaryUrl = () => {
  return `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = () => {
  return [`/api/dashboard/summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Counts and recent activity for the dashboard
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all templates (built-in + user-created) with optional filter
 */
export const getListTemplatesUrl = (params?: ListTemplatesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/templates?${stringifiedParams}`
    : `/api/templates`;
};

export const listTemplates = async (
  params?: ListTemplatesParams,
  options?: RequestInit,
): Promise<Template[]> => {
  return customFetch<Template[]>(getListTemplatesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTemplatesQueryKey = (params?: ListTemplatesParams) => {
  return [`/api/templates`, ...(params ? [params] : [])] as const;
};

export const getListTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTemplatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({
    signal,
  }) => listTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTemplates>>
>;
export type ListTemplatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List all templates (built-in + user-created) with optional filter
 */

export function useListTemplates<
  TData = Awaited<ReturnType<typeof listTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a user template
 */
export const getCreateTemplateUrl = () => {
  return `/api/templates`;
};

export const createTemplate = async (
  createTemplateInput: CreateTemplateInput,
  options?: RequestInit,
): Promise<Template> => {
  return customFetch<Template>(getCreateTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTemplateInput),
  });
};

export const getCreateTemplateMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { data: BodyType<CreateTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: BodyType<CreateTemplateInput> },
  TContext
> => {
  const mutationKey = ["createTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplate>>,
    { data: BodyType<CreateTemplateInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTemplate>>
>;
export type CreateTemplateMutationBody = BodyType<CreateTemplateInput>;
export type CreateTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Create a user template
 */
export const useCreateTemplate = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { data: BodyType<CreateTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { data: BodyType<CreateTemplateInput> },
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options));
};

/**
 * @summary Get a single template
 */
export const getGetTemplateUrl = (id: number) => {
  return `/api/templates/${id}`;
};

export const getTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<Template> => {
  return customFetch<Template>(getGetTemplateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTemplateQueryKey = (id: number) => {
  return [`/api/templates/${id}`] as const;
};

export const getGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTemplateQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single template
 */

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a user template
 */
export const getUpdateTemplateUrl = (id: number) => {
  return `/api/templates/${id}`;
};

export const updateTemplate = async (
  id: number,
  updateTemplateInput: UpdateTemplateInput,
  options?: RequestInit,
): Promise<Template> => {
  return customFetch<Template>(getUpdateTemplateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTemplateInput),
  });
};

export const getUpdateTemplateMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateTemplateInput> },
  TContext
> => {
  const mutationKey = ["updateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTemplate>>,
    { id: number; data: BodyType<UpdateTemplateInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTemplate>>
>;
export type UpdateTemplateMutationBody = BodyType<UpdateTemplateInput>;
export type UpdateTemplateMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Update a user template
 */
export const useUpdateTemplate = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { id: number; data: BodyType<UpdateTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { id: number; data: BodyType<UpdateTemplateInput> },
  TContext
> => {
  return useMutation(getUpdateTemplateMutationOptions(options));
};

/**
 * For user-owned templates this sets `deletedAt = now()` so the row is hidden from listings/render/send paths but can be restored from the Trash. For built-in templates the existing admin-only hide behavior continues to apply (sets `hiddenAt`).

 * @summary Move a user template to the Trash (soft-delete) or hide a built-in globally
 */
export const getDeleteTemplateUrl = (id: number) => {
  return `/api/templates/${id}`;
};

export const deleteTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTemplateMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTemplate>>
>;

export type DeleteTemplateMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Move a user template to the Trash (soft-delete) or hide a built-in globally
 */
export const useDeleteTemplate = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTemplateMutationOptions(options));
};

/**
 * @summary Delete multiple templates at once (max 200 per call). Owners may move their own templates to Trash; only admins may hide built-ins globally. Unauthorized items return a forbidden outcome instead of failing the batch.
 */
export const getBulkDeleteTemplatesUrl = () => {
  return `/api/templates/bulk-delete`;
};

export const bulkDeleteTemplates = async (
  bulkDeleteTemplatesInput: BulkDeleteTemplatesInput,
  options?: RequestInit,
): Promise<BulkDeleteTemplatesResult> => {
  return customFetch<BulkDeleteTemplatesResult>(getBulkDeleteTemplatesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkDeleteTemplatesInput),
  });
};

export const getBulkDeleteTemplatesMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteTemplates>>,
    TError,
    { data: BodyType<BulkDeleteTemplatesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteTemplates>>,
  TError,
  { data: BodyType<BulkDeleteTemplatesInput> },
  TContext
> => {
  const mutationKey = ["bulkDeleteTemplates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteTemplates>>,
    { data: BodyType<BulkDeleteTemplatesInput> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDeleteTemplates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteTemplatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteTemplates>>
>;
export type BulkDeleteTemplatesMutationBody =
  BodyType<BulkDeleteTemplatesInput>;
export type BulkDeleteTemplatesMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Delete multiple templates at once (max 200 per call). Owners may move their own templates to Trash; only admins may hide built-ins globally. Unauthorized items return a forbidden outcome instead of failing the batch.
 */
export const useBulkDeleteTemplates = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteTemplates>>,
    TError,
    { data: BodyType<BulkDeleteTemplatesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteTemplates>>,
  TError,
  { data: BodyType<BulkDeleteTemplatesInput> },
  TContext
> => {
  return useMutation(getBulkDeleteTemplatesMutationOptions(options));
};

/**
 * Returns the signed-in user's own templates that have been moved to the Trash (i.e. `deletedAt IS NOT NULL`). Built-in templates are never included regardless of their `hiddenAt` state. The most recently deleted templates are returned first.

 * @summary List the current user's soft-deleted templates (Trash)
 */
export const getListTrashedTemplatesUrl = () => {
  return `/api/templates/trash`;
};

export const listTrashedTemplates = async (
  options?: RequestInit,
): Promise<Template[]> => {
  return customFetch<Template[]>(getListTrashedTemplatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTrashedTemplatesQueryKey = () => {
  return [`/api/templates/trash`] as const;
};

export const getListTrashedTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrashedTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrashedTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTrashedTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrashedTemplates>>
  > = ({ signal }) => listTrashedTemplates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrashedTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrashedTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrashedTemplates>>
>;
export type ListTrashedTemplatesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the current user's soft-deleted templates (Trash)
 */

export function useListTrashedTemplates<
  TData = Awaited<ReturnType<typeof listTrashedTemplates>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrashedTemplates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrashedTemplatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Clears `deletedAt` on the given template (which must currently be in the Trash and owned by the signed-in user). If the original slug now collides with an active template owned by the same user (because they created a new one with the same name while this template was trashed), the restored template's slug is auto- suffixed using the same helper used by create/rename.

 * @summary Restore a soft-deleted user template from the Trash
 */
export const getRestoreTemplateUrl = (id: number) => {
  return `/api/templates/${id}/restore`;
};

export const restoreTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<Template> => {
  return customFetch<Template>(getRestoreTemplateUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreTemplateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreTemplate>>
>;

export type RestoreTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ErrorResponse
>;

/**
 * @summary Restore a soft-deleted user template from the Trash
 */
export const useRestoreTemplate = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreTemplateMutationOptions(options));
};

/**
 * Hard-deletes a soft-deleted template owned by the signed-in user. The template must currently be in the Trash (i.e. `deletedAt IS NOT NULL`); active templates must first be moved to the Trash via `DELETE /templates/{id}`.

 * @summary Permanently delete a user template that is currently in the Trash
 */
export const getPurgeTemplateUrl = (id: number) => {
  return `/api/templates/${id}/purge`;
};

export const purgeTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getPurgeTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getPurgeTemplateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purgeTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purgeTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["purgeTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purgeTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return purgeTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurgeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof purgeTemplate>>
>;

export type PurgeTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Permanently delete a user template that is currently in the Trash
 */
export const usePurgeTemplate = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purgeTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof purgeTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPurgeTemplateMutationOptions(options));
};

/**
 * @summary Render a template with variables and brand context (HTML preview)
 */
export const getRenderTemplateUrl = (id: number) => {
  return `/api/templates/${id}/render`;
};

export const renderTemplate = async (
  id: number,
  renderTemplateInput: RenderTemplateInput,
  options?: RequestInit,
): Promise<RenderedEmail> => {
  return customFetch<RenderedEmail>(getRenderTemplateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(renderTemplateInput),
  });
};

export const getRenderTemplateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderTemplate>>,
    TError,
    { id: number; data: BodyType<RenderTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renderTemplate>>,
  TError,
  { id: number; data: BodyType<RenderTemplateInput> },
  TContext
> => {
  const mutationKey = ["renderTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renderTemplate>>,
    { id: number; data: BodyType<RenderTemplateInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return renderTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenderTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof renderTemplate>>
>;
export type RenderTemplateMutationBody = BodyType<RenderTemplateInput>;
export type RenderTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Render a template with variables and brand context (HTML preview)
 */
export const useRenderTemplate = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderTemplate>>,
    TError,
    { id: number; data: BodyType<RenderTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renderTemplate>>,
  TError,
  { id: number; data: BodyType<RenderTemplateInput> },
  TContext
> => {
  return useMutation(getRenderTemplateMutationOptions(options));
};

/**
 * @summary Fetch initial values for the template's auto-generated variables (e.g. case-reference counters). Each call advances any underlying counter, so the compose page should call it once per session.

 */
export const getGetTemplateAutoDefaultsUrl = (id: number) => {
  return `/api/templates/${id}/auto-defaults`;
};

export const getTemplateAutoDefaults = async (
  id: number,
  options?: RequestInit,
): Promise<TemplateAutoDefaults> => {
  return customFetch<TemplateAutoDefaults>(getGetTemplateAutoDefaultsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTemplateAutoDefaultsQueryKey = (id: number) => {
  return [`/api/templates/${id}/auto-defaults`] as const;
};

export const getGetTemplateAutoDefaultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplateAutoDefaults>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplateAutoDefaults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemplateAutoDefaultsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemplateAutoDefaults>>
  > = ({ signal }) =>
    getTemplateAutoDefaults(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateAutoDefaults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemplateAutoDefaultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateAutoDefaults>>
>;
export type GetTemplateAutoDefaultsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Fetch initial values for the template's auto-generated variables (e.g. case-reference counters). Each call advances any underlying counter, so the compose page should call it once per session.

 */

export function useGetTemplateAutoDefaults<
  TData = Awaited<ReturnType<typeof getTemplateAutoDefaults>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplateAutoDefaults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemplateAutoDefaultsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the catalogue the multi-client preview UI uses to render its tabs. Each entry includes the iframe viewport width and the client's known quirks so the UI can describe what the preview does and does not approximate. The list is static — clients should cache it for the page session.

 * @summary List the available email-client preview profiles (Gmail Web, Gmail Mobile, Apple Mail, Outlook Desktop, Outlook Web).
 */
export const getListPreviewClientsUrl = () => {
  return `/api/preview-clients`;
};

export const listPreviewClients = async (
  options?: RequestInit,
): Promise<ClientPreviewProfile[]> => {
  return customFetch<ClientPreviewProfile[]>(getListPreviewClientsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPreviewClientsQueryKey = () => {
  return [`/api/preview-clients`] as const;
};

export const getListPreviewClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPreviewClients>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPreviewClients>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPreviewClientsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPreviewClients>>
  > = ({ signal }) => listPreviewClients({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPreviewClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPreviewClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPreviewClients>>
>;
export type ListPreviewClientsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the available email-client preview profiles (Gmail Web, Gmail Mobile, Apple Mail, Outlook Desktop, Outlook Web).
 */

export function useListPreviewClients<
  TData = Awaited<ReturnType<typeof listPreviewClients>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPreviewClients>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPreviewClientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Runs the same render pipeline as `POST /templates/{id}/render`, then post-processes the resulting HTML to approximate how the target email client would display it (e.g. Outlook Desktop strips border-radius and CSS background-image; Gmail Mobile uses a narrow viewport). Returns the post-processed HTML plus a list of compatibility issues the post-processor detected so the UI can show a "what's different in this client" panel beneath the preview.

 * @summary Render a template through one client profile's quirks pipeline (multi-client preview)
 */
export const getPreviewTemplateForClientUrl = (id: number) => {
  return `/api/templates/${id}/preview-client`;
};

export const previewTemplateForClient = async (
  id: number,
  previewTemplateForClientInput: PreviewTemplateForClientInput,
  options?: RequestInit,
): Promise<RenderedClientPreview> => {
  return customFetch<RenderedClientPreview>(
    getPreviewTemplateForClientUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(previewTemplateForClientInput),
    },
  );
};

export const getPreviewTemplateForClientMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemplateForClient>>,
    TError,
    { id: number; data: BodyType<PreviewTemplateForClientInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewTemplateForClient>>,
  TError,
  { id: number; data: BodyType<PreviewTemplateForClientInput> },
  TContext
> => {
  const mutationKey = ["previewTemplateForClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewTemplateForClient>>,
    { id: number; data: BodyType<PreviewTemplateForClientInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewTemplateForClient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewTemplateForClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewTemplateForClient>>
>;
export type PreviewTemplateForClientMutationBody =
  BodyType<PreviewTemplateForClientInput>;
export type PreviewTemplateForClientMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Render a template through one client profile's quirks pipeline (multi-client preview)
 */
export const usePreviewTemplateForClient = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ErrorResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemplateForClient>>,
    TError,
    { id: number; data: BodyType<PreviewTemplateForClientInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewTemplateForClient>>,
  TError,
  { id: number; data: BodyType<PreviewTemplateForClientInput> },
  TContext
> => {
  return useMutation(getPreviewTemplateForClientMutationOptions(options));
};

/**
 * Returns engagement counters for one template scoped to the signed-in user's own `live` sends. Mirrors the dashboard's engagement aggregation (bot events excluded, unique-per-log numerators, rates clamped to [0, 1]) but reduced to a single template id so the template detail page can show per-template trends. The 30-day series is zero-filled so the trend chart always renders 30 entries even on quiet templates. Built-in templates are addressable, but only logs sent by the current user are counted (no cross-user leakage).

 * @summary Lifetime + 30-day open / click engagement metrics for a single template
 */
export const getGetTemplateEngagementUrl = (id: number) => {
  return `/api/templates/${id}/engagement`;
};

export const getTemplateEngagement = async (
  id: number,
  options?: RequestInit,
): Promise<TemplateEngagement> => {
  return customFetch<TemplateEngagement>(getGetTemplateEngagementUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTemplateEngagementQueryKey = (id: number) => {
  return [`/api/templates/${id}/engagement`] as const;
};

export const getGetTemplateEngagementQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplateEngagement>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplateEngagement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemplateEngagementQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemplateEngagement>>
  > = ({ signal }) => getTemplateEngagement(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateEngagement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemplateEngagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateEngagement>>
>;
export type GetTemplateEngagementQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Lifetime + 30-day open / click engagement metrics for a single template
 */

export function useGetTemplateEngagement<
  TData = Awaited<ReturnType<typeof getTemplateEngagement>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemplateEngagement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemplateEngagementQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Inspects the template's `bodyHtml`, parses out every distinct `{{> slug …}}` reference, and returns the matching snippet rows (built-in + user-owned). The detail page surfaces this as the "Used snippets" panel beside the body editor.

 * @summary List the snippets a template's body references via {{> slug}} partials
 */
export const getListTemplateUsedSnippetsUrl = (id: number) => {
  return `/api/templates/${id}/used-snippets`;
};

export const listTemplateUsedSnippets = async (
  id: number,
  options?: RequestInit,
): Promise<TemplateSnippet[]> => {
  return customFetch<TemplateSnippet[]>(getListTemplateUsedSnippetsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListTemplateUsedSnippetsQueryKey = (id: number) => {
  return [`/api/templates/${id}/used-snippets`] as const;
};

export const getListTemplateUsedSnippetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTemplateUsedSnippets>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplateUsedSnippets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTemplateUsedSnippetsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTemplateUsedSnippets>>
  > = ({ signal }) =>
    listTemplateUsedSnippets(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTemplateUsedSnippets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTemplateUsedSnippetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTemplateUsedSnippets>>
>;
export type ListTemplateUsedSnippetsQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List the snippets a template's body references via {{> slug}} partials
 */

export function useListTemplateUsedSnippets<
  TData = Awaited<ReturnType<typeof listTemplateUsedSnippets>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTemplateUsedSnippets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTemplateUsedSnippetsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List every snippet visible to the current user (built-ins + own)
 */
export const getListSnippetsUrl = () => {
  return `/api/snippets`;
};

export const listSnippets = async (
  options?: RequestInit,
): Promise<TemplateSnippetWithUsage[]> => {
  return customFetch<TemplateSnippetWithUsage[]>(getListSnippetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSnippetsQueryKey = () => {
  return [`/api/snippets`] as const;
};

export const getListSnippetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSnippets>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSnippets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSnippetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSnippets>>> = ({
    signal,
  }) => listSnippets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSnippets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSnippetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSnippets>>
>;
export type ListSnippetsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List every snippet visible to the current user (built-ins + own)
 */

export function useListSnippets<
  TData = Awaited<ReturnType<typeof listSnippets>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSnippets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSnippetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a user-owned snippet
 */
export const getCreateSnippetUrl = () => {
  return `/api/snippets`;
};

export const createSnippet = async (
  createSnippetInput: CreateSnippetInput,
  options?: RequestInit,
): Promise<TemplateSnippet> => {
  return customFetch<TemplateSnippet>(getCreateSnippetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSnippetInput),
  });
};

export const getCreateSnippetMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSnippet>>,
    TError,
    { data: BodyType<CreateSnippetInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSnippet>>,
  TError,
  { data: BodyType<CreateSnippetInput> },
  TContext
> => {
  const mutationKey = ["createSnippet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSnippet>>,
    { data: BodyType<CreateSnippetInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createSnippet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSnippetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSnippet>>
>;
export type CreateSnippetMutationBody = BodyType<CreateSnippetInput>;
export type CreateSnippetMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Create a user-owned snippet
 */
export const useCreateSnippet = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSnippet>>,
    TError,
    { data: BodyType<CreateSnippetInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSnippet>>,
  TError,
  { data: BodyType<CreateSnippetInput> },
  TContext
> => {
  return useMutation(getCreateSnippetMutationOptions(options));
};

/**
 * @summary Get a single snippet (built-in or owned)
 */
export const getGetSnippetUrl = (id: number) => {
  return `/api/snippets/${id}`;
};

export const getSnippet = async (
  id: number,
  options?: RequestInit,
): Promise<TemplateSnippet> => {
  return customFetch<TemplateSnippet>(getGetSnippetUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSnippetQueryKey = (id: number) => {
  return [`/api/snippets/${id}`] as const;
};

export const getGetSnippetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnippet>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnippet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnippetQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnippet>>> = ({
    signal,
  }) => getSnippet(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnippet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSnippetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnippet>>
>;
export type GetSnippetQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single snippet (built-in or owned)
 */

export function useGetSnippet<
  TData = Awaited<ReturnType<typeof getSnippet>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnippet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSnippetQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a user-owned snippet
 */
export const getUpdateSnippetUrl = (id: number) => {
  return `/api/snippets/${id}`;
};

export const updateSnippet = async (
  id: number,
  updateSnippetInput: UpdateSnippetInput,
  options?: RequestInit,
): Promise<TemplateSnippet> => {
  return customFetch<TemplateSnippet>(getUpdateSnippetUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSnippetInput),
  });
};

export const getUpdateSnippetMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSnippet>>,
    TError,
    { id: number; data: BodyType<UpdateSnippetInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSnippet>>,
  TError,
  { id: number; data: BodyType<UpdateSnippetInput> },
  TContext
> => {
  const mutationKey = ["updateSnippet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSnippet>>,
    { id: number; data: BodyType<UpdateSnippetInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSnippet(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSnippetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSnippet>>
>;
export type UpdateSnippetMutationBody = BodyType<UpdateSnippetInput>;
export type UpdateSnippetMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Update a user-owned snippet
 */
export const useUpdateSnippet = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSnippet>>,
    TError,
    { id: number; data: BodyType<UpdateSnippetInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSnippet>>,
  TError,
  { id: number; data: BodyType<UpdateSnippetInput> },
  TContext
> => {
  return useMutation(getUpdateSnippetMutationOptions(options));
};

/**
 * Hard-deletes the snippet. If at least one of the user's templates currently references the snippet via `{{> slug}}`, the request is refused with a 409 carrying the dependent templates so the UI can ask the user to remove the references first. Built-in snippets cannot be deleted; users can shadow them by creating an owned snippet with the same slug.

 * @summary Delete a user-owned snippet (refuses if any templates reference its slug)
 */
export const getDeleteSnippetUrl = (id: number) => {
  return `/api/snippets/${id}`;
};

export const deleteSnippet = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSnippetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSnippetMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | SnippetDeleteConflict
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnippet>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSnippet>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSnippet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSnippet>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSnippet(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSnippetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSnippet>>
>;

export type DeleteSnippetMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | SnippetDeleteConflict
>;

/**
 * @summary Delete a user-owned snippet (refuses if any templates reference its slug)
 */
export const useDeleteSnippet = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | SnippetDeleteConflict
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnippet>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSnippet>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSnippetMutationOptions(options));
};

/**
 * @summary List the templates that currently reference this snippet
 */
export const getGetSnippetUsageUrl = (id: number) => {
  return `/api/snippets/${id}/usage`;
};

export const getSnippetUsage = async (
  id: number,
  options?: RequestInit,
): Promise<SnippetUsage> => {
  return customFetch<SnippetUsage>(getGetSnippetUsageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSnippetUsageQueryKey = (id: number) => {
  return [`/api/snippets/${id}/usage`] as const;
};

export const getGetSnippetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnippetUsage>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnippetUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnippetUsageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnippetUsage>>> = ({
    signal,
  }) => getSnippetUsage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnippetUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSnippetUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnippetUsage>>
>;
export type GetSnippetUsageQueryError = ErrorType<
  UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List the templates that currently reference this snippet
 */

export function useGetSnippetUsage<
  TData = Awaited<ReturnType<typeof getSnippetUsage>>,
  TError = ErrorType<UnauthorizedResponse | NotFoundResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnippetUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSnippetUsageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update the signed-in user's per-user preferences (sending defaults)
 */
export const getUpdateMePreferencesUrl = () => {
  return `/api/me/preferences`;
};

export const updateMePreferences = async (
  updateMePreferencesInput: UpdateMePreferencesInput,
  options?: RequestInit,
): Promise<User> => {
  return customFetch<User>(getUpdateMePreferencesUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMePreferencesInput),
  });
};

export const getUpdateMePreferencesMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMePreferences>>,
    TError,
    { data: BodyType<UpdateMePreferencesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMePreferences>>,
  TError,
  { data: BodyType<UpdateMePreferencesInput> },
  TContext
> => {
  const mutationKey = ["updateMePreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMePreferences>>,
    { data: BodyType<UpdateMePreferencesInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMePreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMePreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMePreferences>>
>;
export type UpdateMePreferencesMutationBody =
  BodyType<UpdateMePreferencesInput>;
export type UpdateMePreferencesMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Update the signed-in user's per-user preferences (sending defaults)
 */
export const useUpdateMePreferences = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMePreferences>>,
    TError,
    { data: BodyType<UpdateMePreferencesInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMePreferences>>,
  TError,
  { data: BodyType<UpdateMePreferencesInput> },
  TContext
> => {
  return useMutation(getUpdateMePreferencesMutationOptions(options));
};

/**
 * @summary Get the actual sender address recipients will see (verified Resend sender + brand From name)
 */
export const getGetSenderAddressUrl = () => {
  return `/api/sender`;
};

export const getSenderAddress = async (
  options?: RequestInit,
): Promise<SenderAddress> => {
  return customFetch<SenderAddress>(getGetSenderAddressUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSenderAddressQueryKey = () => {
  return [`/api/sender`] as const;
};

export const getGetSenderAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getSenderAddress>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSenderAddress>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSenderAddressQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSenderAddress>>
  > = ({ signal }) => getSenderAddress({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSenderAddress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSenderAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSenderAddress>>
>;
export type GetSenderAddressQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get the actual sender address recipients will see (verified Resend sender + brand From name)
 */

export function useGetSenderAddress<
  TData = Awaited<ReturnType<typeof getSenderAddress>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSenderAddress>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSenderAddressQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the SPF (TXT), DKIM (CNAME or TXT), and Return-Path/MAIL FROM (MX + TXT on a `send.<domain>` subdomain) records that Resend reports for the configured sending domain, plus a synthesized recommended DMARC record. Each row is shaped for the Brand Settings copy-paste panel and includes Resend's per-record verification status. If no sending domain is configured the response carries an empty list and a human-readable `reason`. This endpoint is display-only — it does not mutate DNS or trigger any verification.

 * @summary Canonical DNS records the user must add for their sending domain (Cloudflare-friendly)
 */
export const getGetSenderDnsRecordsUrl = () => {
  return `/api/sender/dns-records`;
};

export const getSenderDnsRecords = async (
  options?: RequestInit,
): Promise<SenderDnsRecords> => {
  return customFetch<SenderDnsRecords>(getGetSenderDnsRecordsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSenderDnsRecordsQueryKey = () => {
  return [`/api/sender/dns-records`] as const;
};

export const getGetSenderDnsRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSenderDnsRecords>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSenderDnsRecords>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSenderDnsRecordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSenderDnsRecords>>
  > = ({ signal }) => getSenderDnsRecords({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSenderDnsRecords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSenderDnsRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSenderDnsRecords>>
>;
export type GetSenderDnsRecordsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Canonical DNS records the user must add for their sending domain (Cloudflare-friendly)
 */

export function useGetSenderDnsRecords<
  TData = Awaited<ReturnType<typeof getSenderDnsRecords>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSenderDnsRecords>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSenderDnsRecordsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get brand settings (auto-created defaults if missing)
 */
export const getGetBrandSettingsUrl = () => {
  return `/api/brand`;
};

export const getBrandSettings = async (
  options?: RequestInit,
): Promise<BrandSettings> => {
  return customFetch<BrandSettings>(getGetBrandSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBrandSettingsQueryKey = () => {
  return [`/api/brand`] as const;
};

export const getGetBrandSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBrandSettings>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrandSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBrandSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBrandSettings>>
  > = ({ signal }) => getBrandSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBrandSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBrandSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBrandSettings>>
>;
export type GetBrandSettingsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get brand settings (auto-created defaults if missing)
 */

export function useGetBrandSettings<
  TData = Awaited<ReturnType<typeof getBrandSettings>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBrandSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBrandSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update brand settings
 */
export const getUpdateBrandSettingsUrl = () => {
  return `/api/brand`;
};

export const updateBrandSettings = async (
  updateBrandSettingsInput: UpdateBrandSettingsInput,
  options?: RequestInit,
): Promise<BrandSettings> => {
  return customFetch<BrandSettings>(getUpdateBrandSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBrandSettingsInput),
  });
};

export const getUpdateBrandSettingsMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | UpdateBrandSettings403
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBrandSettings>>,
    TError,
    { data: BodyType<UpdateBrandSettingsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBrandSettings>>,
  TError,
  { data: BodyType<UpdateBrandSettingsInput> },
  TContext
> => {
  const mutationKey = ["updateBrandSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBrandSettings>>,
    { data: BodyType<UpdateBrandSettingsInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateBrandSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBrandSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBrandSettings>>
>;
export type UpdateBrandSettingsMutationBody =
  BodyType<UpdateBrandSettingsInput>;
export type UpdateBrandSettingsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | UpdateBrandSettings403
>;

/**
 * @summary Update brand settings
 */
export const useUpdateBrandSettings = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | UpdateBrandSettings403
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBrandSettings>>,
    TError,
    { data: BodyType<UpdateBrandSettingsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBrandSettings>>,
  TError,
  { data: BodyType<UpdateBrandSettingsInput> },
  TContext
> => {
  return useMutation(getUpdateBrandSettingsMutationOptions(options));
};

/**
 * Returns the per-workspace allow-list of sender domains that earn the small blue "Verified sender" badge in the UI, in addition to the curated baseline shipped in the client. Any signed-in user can read this — the list is workspace-wide and the UI needs it to render badges on every inbox row.

 * @summary List the workspace's custom trusted-sender domains
 */
export const getListTrustedSendersUrl = () => {
  return `/api/trusted-senders`;
};

export const listTrustedSenders = async (
  options?: RequestInit,
): Promise<TrustedSenderList> => {
  return customFetch<TrustedSenderList>(getListTrustedSendersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTrustedSendersQueryKey = () => {
  return [`/api/trusted-senders`] as const;
};

export const getListTrustedSendersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrustedSenders>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrustedSenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTrustedSendersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrustedSenders>>
  > = ({ signal }) => listTrustedSenders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrustedSenders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrustedSendersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrustedSenders>>
>;
export type ListTrustedSendersQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the workspace's custom trusted-sender domains
 */

export function useListTrustedSenders<
  TData = Awaited<ReturnType<typeof listTrustedSenders>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listTrustedSenders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrustedSendersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Admin-only. Lower-cases and trims the supplied domain, validates it loosely as a registrable hostname (labels of `[a-z0-9-]` separated by dots, two or more labels), and rejects entries that are already on the curated baseline or already saved for this workspace. Returns the persisted row on success.

 * @summary Add a custom trusted-sender domain to the workspace
 */
export const getCreateTrustedSenderUrl = () => {
  return `/api/trusted-senders`;
};

export const createTrustedSender = async (
  createTrustedSenderInput: CreateTrustedSenderInput,
  options?: RequestInit,
): Promise<TrustedSender> => {
  return customFetch<TrustedSender>(getCreateTrustedSenderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTrustedSenderInput),
  });
};

export const getCreateTrustedSenderMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrustedSender>>,
    TError,
    { data: BodyType<CreateTrustedSenderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrustedSender>>,
  TError,
  { data: BodyType<CreateTrustedSenderInput> },
  TContext
> => {
  const mutationKey = ["createTrustedSender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrustedSender>>,
    { data: BodyType<CreateTrustedSenderInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrustedSender(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrustedSenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrustedSender>>
>;
export type CreateTrustedSenderMutationBody =
  BodyType<CreateTrustedSenderInput>;
export type CreateTrustedSenderMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ErrorResponse
>;

/**
 * @summary Add a custom trusted-sender domain to the workspace
 */
export const useCreateTrustedSender = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrustedSender>>,
    TError,
    { data: BodyType<CreateTrustedSenderInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrustedSender>>,
  TError,
  { data: BodyType<CreateTrustedSenderInput> },
  TContext
> => {
  return useMutation(getCreateTrustedSenderMutationOptions(options));
};

/**
 * Admin-only. The id must belong to the requester's own workspace; rows owned by another workspace return 404.

 * @summary Remove a custom trusted-sender domain from the workspace
 */
export const getDeleteTrustedSenderUrl = (id: number) => {
  return `/api/trusted-senders/${id}`;
};

export const deleteTrustedSender = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTrustedSenderUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrustedSenderMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrustedSender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrustedSender>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTrustedSender"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrustedSender>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrustedSender(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrustedSenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrustedSender>>
>;

export type DeleteTrustedSenderMutationError = ErrorType<
  UnauthorizedResponse | ErrorResponse | NotFoundResponse
>;

/**
 * @summary Remove a custom trusted-sender domain from the workspace
 */
export const useDeleteTrustedSender = <
  TError = ErrorType<UnauthorizedResponse | ErrorResponse | NotFoundResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrustedSender>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrustedSender>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTrustedSenderMutationOptions(options));
};

/**
 * @summary List the current user's contacts
 */
export const getListContactsUrl = () => {
  return `/api/contacts`;
};

export const listContacts = async (
  options?: RequestInit,
): Promise<Contact[]> => {
  return customFetch<Contact[]>(getListContactsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListContactsQueryKey = () => {
  return [`/api/contacts`] as const;
};

export const getListContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContacts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContactsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContacts>>> = ({
    signal,
  }) => listContacts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContacts>>
>;
export type ListContactsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the current user's contacts
 */

export function useListContacts<
  TData = Awaited<ReturnType<typeof listContacts>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listContacts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new contact
 */
export const getCreateContactUrl = () => {
  return `/api/contacts`;
};

export const createContact = async (
  createContactInput: CreateContactInput,
  options?: RequestInit,
): Promise<CreateContactResponse> => {
  return customFetch<CreateContactResponse>(getCreateContactUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createContactInput),
  });
};

export const getCreateContactMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ContactValidationError | UnauthorizedResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContact>>,
    TError,
    { data: BodyType<CreateContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  { data: BodyType<CreateContactInput> },
  TContext
> => {
  const mutationKey = ["createContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContact>>,
    { data: BodyType<CreateContactInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContact>>
>;
export type CreateContactMutationBody = BodyType<CreateContactInput>;
export type CreateContactMutationError = ErrorType<
  ErrorResponse | ContactValidationError | UnauthorizedResponse
>;

/**
 * @summary Create a new contact
 */
export const useCreateContact = <
  TError = ErrorType<
    ErrorResponse | ContactValidationError | UnauthorizedResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContact>>,
    TError,
    { data: BodyType<CreateContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  { data: BodyType<CreateContactInput> },
  TContext
> => {
  return useMutation(getCreateContactMutationOptions(options));
};

/**
 * Validates each supplied row's email with Abstract API (cached). Rows whose email is `invalid` are skipped unless the request includes `allowInvalid: true`. `risky` rows are always saved with a warning badge. Returns a per-row result plus a summary count so the UI can render the import preview and surface the "Import anyway" override.

 * @summary Validate and (optionally) persist a batch of contacts
 */
export const getBulkImportContactsUrl = () => {
  return `/api/contacts/bulk-import`;
};

export const bulkImportContacts = async (
  bulkImportContactsInput: BulkImportContactsInput,
  options?: RequestInit,
): Promise<ContactImportSummary> => {
  return customFetch<ContactImportSummary>(getBulkImportContactsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkImportContactsInput),
  });
};

export const getBulkImportContactsMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkImportContacts>>,
    TError,
    { data: BodyType<BulkImportContactsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkImportContacts>>,
  TError,
  { data: BodyType<BulkImportContactsInput> },
  TContext
> => {
  const mutationKey = ["bulkImportContacts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkImportContacts>>,
    { data: BodyType<BulkImportContactsInput> }
  > = (props) => {
    const { data } = props ?? {};

    return bulkImportContacts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkImportContactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkImportContacts>>
>;
export type BulkImportContactsMutationBody = BodyType<BulkImportContactsInput>;
export type BulkImportContactsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Validate and (optionally) persist a batch of contacts
 */
export const useBulkImportContacts = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkImportContacts>>,
    TError,
    { data: BodyType<BulkImportContactsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkImportContacts>>,
  TError,
  { data: BodyType<BulkImportContactsInput> },
  TContext
> => {
  return useMutation(getBulkImportContactsMutationOptions(options));
};

/**
 * @summary Update a contact
 */
export const getUpdateContactUrl = (id: number) => {
  return `/api/contacts/${id}`;
};

export const updateContact = async (
  id: number,
  updateContactInput: UpdateContactInput,
  options?: RequestInit,
): Promise<Contact> => {
  return customFetch<Contact>(getUpdateContactUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateContactInput),
  });
};

export const getUpdateContactMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContact>>,
    TError,
    { id: number; data: BodyType<UpdateContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  { id: number; data: BodyType<UpdateContactInput> },
  TContext
> => {
  const mutationKey = ["updateContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContact>>,
    { id: number; data: BodyType<UpdateContactInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContact>>
>;
export type UpdateContactMutationBody = BodyType<UpdateContactInput>;
export type UpdateContactMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Update a contact
 */
export const useUpdateContact = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContact>>,
    TError,
    { id: number; data: BodyType<UpdateContactInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  { id: number; data: BodyType<UpdateContactInput> },
  TContext
> => {
  return useMutation(getUpdateContactMutationOptions(options));
};

/**
 * @summary Delete a contact
 */
export const getDeleteContactUrl = (id: number) => {
  return `/api/contacts/${id}`;
};

export const deleteContact = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteContactUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteContactMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContact>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteContact(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContact>>
>;

export type DeleteContactMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Delete a contact
 */
export const useDeleteContact = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContact>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteContactMutationOptions(options));
};

/**
 * @summary Get current user's representative defaults (empty defaults if unset)
 */
export const getGetRepDefaultsUrl = () => {
  return `/api/rep-defaults`;
};

export const getRepDefaults = async (
  options?: RequestInit,
): Promise<RepDefaults> => {
  return customFetch<RepDefaults>(getGetRepDefaultsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRepDefaultsQueryKey = () => {
  return [`/api/rep-defaults`] as const;
};

export const getGetRepDefaultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepDefaults>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRepDefaults>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepDefaultsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepDefaults>>> = ({
    signal,
  }) => getRepDefaults({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepDefaults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRepDefaultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRepDefaults>>
>;
export type GetRepDefaultsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Get current user's representative defaults (empty defaults if unset)
 */

export function useGetRepDefaults<
  TData = Awaited<ReturnType<typeof getRepDefaults>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRepDefaults>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRepDefaultsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Upsert the current user's representative defaults
 */
export const getUpdateRepDefaultsUrl = () => {
  return `/api/rep-defaults`;
};

export const updateRepDefaults = async (
  updateRepDefaultsInput: UpdateRepDefaultsInput,
  options?: RequestInit,
): Promise<RepDefaults> => {
  return customFetch<RepDefaults>(getUpdateRepDefaultsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateRepDefaultsInput),
  });
};

export const getUpdateRepDefaultsMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRepDefaults>>,
    TError,
    { data: BodyType<UpdateRepDefaultsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRepDefaults>>,
  TError,
  { data: BodyType<UpdateRepDefaultsInput> },
  TContext
> => {
  const mutationKey = ["updateRepDefaults"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRepDefaults>>,
    { data: BodyType<UpdateRepDefaultsInput> }
  > = (props) => {
    const { data } = props ?? {};

    return updateRepDefaults(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRepDefaultsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRepDefaults>>
>;
export type UpdateRepDefaultsMutationBody = BodyType<UpdateRepDefaultsInput>;
export type UpdateRepDefaultsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Upsert the current user's representative defaults
 */
export const useUpdateRepDefaults = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRepDefaults>>,
    TError,
    { data: BodyType<UpdateRepDefaultsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRepDefaults>>,
  TError,
  { data: BodyType<UpdateRepDefaultsInput> },
  TContext
> => {
  return useMutation(getUpdateRepDefaultsMutationOptions(options));
};

/**
 * Drops the rep's case-reference cursor row so the next compose load re-emits their saved Case ID verbatim. Useful when a number was consumed by a draft that was never sent. Has no effect if no Case ID is saved.

 * @summary Reset the per-user case-reference cursor back to the saved Case ID seed
 */
export const getResetCaseReferenceCursorUrl = () => {
  return `/api/rep-defaults/case-reference/reset`;
};

export const resetCaseReferenceCursor = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getResetCaseReferenceCursorUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResetCaseReferenceCursorMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCaseReferenceCursor>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCaseReferenceCursor>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resetCaseReferenceCursor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCaseReferenceCursor>>,
    void
  > = () => {
    return resetCaseReferenceCursor(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetCaseReferenceCursorMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetCaseReferenceCursor>>
>;

export type ResetCaseReferenceCursorMutationError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Reset the per-user case-reference cursor back to the saved Case ID seed
 */
export const useResetCaseReferenceCursor = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCaseReferenceCursor>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCaseReferenceCursor>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResetCaseReferenceCursorMutationOptions(options));
};

/**
 * Returns the value `nextCaseReferenceForUser` would hand out on its
next call, but without advancing the per-user cursor. Powers the
"Next compose will use: …" hint on the Representative Profile
page so reps can see where the auto-incrementing serial currently
stands without having to open the Compose page (which would
itself consume a number).

`nextCaseReference` is `null` when the saved Case ID is empty or
has no trailing digits — in that case the per-template fallback
kicks in at compose time and the UI hides the hint.

 * @summary Peek at the case reference the next compose will use, without consuming it
 */
export const getPeekNextCaseReferenceUrl = () => {
  return `/api/rep-defaults/next-case-reference`;
};

export const peekNextCaseReference = async (
  options?: RequestInit,
): Promise<NextCaseReference> => {
  return customFetch<NextCaseReference>(getPeekNextCaseReferenceUrl(), {
    ...options,
    method: "GET",
  });
};

export const getPeekNextCaseReferenceQueryKey = () => {
  return [`/api/rep-defaults/next-case-reference`] as const;
};

export const getPeekNextCaseReferenceQueryOptions = <
  TData = Awaited<ReturnType<typeof peekNextCaseReference>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof peekNextCaseReference>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPeekNextCaseReferenceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof peekNextCaseReference>>
  > = ({ signal }) => peekNextCaseReference({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof peekNextCaseReference>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PeekNextCaseReferenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof peekNextCaseReference>>
>;
export type PeekNextCaseReferenceQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Peek at the case reference the next compose will use, without consuming it
 */

export function usePeekNextCaseReference<
  TData = Awaited<ReturnType<typeof peekNextCaseReference>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof peekNextCaseReference>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPeekNextCaseReferenceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Generate a template's structured JSON + HTML from a natural-language brief
 */
export const getAiGenerateTemplateUrl = () => {
  return `/api/ai/generate-template`;
};

export const aiGenerateTemplate = async (
  aiGenerateInput: AiGenerateInput,
  options?: RequestInit,
): Promise<AiGeneratedDraft> => {
  return customFetch<AiGeneratedDraft>(getAiGenerateTemplateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiGenerateInput),
  });
};

export const getAiGenerateTemplateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiGenerateTemplate>>,
    TError,
    { data: BodyType<AiGenerateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiGenerateTemplate>>,
  TError,
  { data: BodyType<AiGenerateInput> },
  TContext
> => {
  const mutationKey = ["aiGenerateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiGenerateTemplate>>,
    { data: BodyType<AiGenerateInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiGenerateTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiGenerateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiGenerateTemplate>>
>;
export type AiGenerateTemplateMutationBody = BodyType<AiGenerateInput>;
export type AiGenerateTemplateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
>;

/**
 * @summary Generate a template's structured JSON + HTML from a natural-language brief
 */
export const useAiGenerateTemplate = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiGenerateTemplate>>,
    TError,
    { data: BodyType<AiGenerateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiGenerateTemplate>>,
  TError,
  { data: BodyType<AiGenerateInput> },
  TContext
> => {
  return useMutation(getAiGenerateTemplateMutationOptions(options));
};

/**
 * @summary Suggest 3–5 subject lines for the current Compose draft
 */
export const getAiSuggestSubjectsUrl = () => {
  return `/api/ai/subjects`;
};

export const aiSuggestSubjects = async (
  aiSubjectsInput: AiSubjectsInput,
  options?: RequestInit,
): Promise<AiSubjectsResponse> => {
  return customFetch<AiSubjectsResponse>(getAiSuggestSubjectsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiSubjectsInput),
  });
};

export const getAiSuggestSubjectsMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiSuggestSubjects>>,
    TError,
    { data: BodyType<AiSubjectsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiSuggestSubjects>>,
  TError,
  { data: BodyType<AiSubjectsInput> },
  TContext
> => {
  const mutationKey = ["aiSuggestSubjects"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiSuggestSubjects>>,
    { data: BodyType<AiSubjectsInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiSuggestSubjects(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiSuggestSubjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiSuggestSubjects>>
>;
export type AiSuggestSubjectsMutationBody = BodyType<AiSubjectsInput>;
export type AiSuggestSubjectsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
>;

/**
 * @summary Suggest 3–5 subject lines for the current Compose draft
 */
export const useAiSuggestSubjects = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiSuggestSubjects>>,
    TError,
    { data: BodyType<AiSubjectsInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiSuggestSubjects>>,
  TError,
  { data: BodyType<AiSubjectsInput> },
  TContext
> => {
  return useMutation(getAiSuggestSubjectsMutationOptions(options));
};

/**
 * @summary Rewrite the current Compose body in the requested tone
 */
export const getAiRewriteToneUrl = () => {
  return `/api/ai/tone`;
};

export const aiRewriteTone = async (
  aiToneInput: AiToneInput,
  options?: RequestInit,
): Promise<AiToneResponse> => {
  return customFetch<AiToneResponse>(getAiRewriteToneUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiToneInput),
  });
};

export const getAiRewriteToneMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiRewriteTone>>,
    TError,
    { data: BodyType<AiToneInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiRewriteTone>>,
  TError,
  { data: BodyType<AiToneInput> },
  TContext
> => {
  const mutationKey = ["aiRewriteTone"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiRewriteTone>>,
    { data: BodyType<AiToneInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiRewriteTone(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiRewriteToneMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiRewriteTone>>
>;
export type AiRewriteToneMutationBody = BodyType<AiToneInput>;
export type AiRewriteToneMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
>;

/**
 * @summary Rewrite the current Compose body in the requested tone
 */
export const useAiRewriteTone = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiRewriteTone>>,
    TError,
    { data: BodyType<AiToneInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiRewriteTone>>,
  TError,
  { data: BodyType<AiToneInput> },
  TContext
> => {
  return useMutation(getAiRewriteToneMutationOptions(options));
};

/**
 * @summary Score the draft for spam-trigger risk and list concrete issues
 */
export const getAiSpamCheckUrl = () => {
  return `/api/ai/spam-check`;
};

export const aiSpamCheck = async (
  aiSpamCheckInput: AiSpamCheckInput,
  options?: RequestInit,
): Promise<AiSpamReport> => {
  return customFetch<AiSpamReport>(getAiSpamCheckUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiSpamCheckInput),
  });
};

export const getAiSpamCheckMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiSpamCheck>>,
    TError,
    { data: BodyType<AiSpamCheckInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiSpamCheck>>,
  TError,
  { data: BodyType<AiSpamCheckInput> },
  TContext
> => {
  const mutationKey = ["aiSpamCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiSpamCheck>>,
    { data: BodyType<AiSpamCheckInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiSpamCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiSpamCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiSpamCheck>>
>;
export type AiSpamCheckMutationBody = BodyType<AiSpamCheckInput>;
export type AiSpamCheckMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
>;

/**
 * @summary Score the draft for spam-trigger risk and list concrete issues
 */
export const useAiSpamCheck = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | AiRateLimitError | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiSpamCheck>>,
    TError,
    { data: BodyType<AiSpamCheckInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiSpamCheck>>,
  TError,
  { data: BodyType<AiSpamCheckInput> },
  TContext
> => {
  return useMutation(getAiSpamCheckMutationOptions(options));
};

/**
 * @summary Draft a follow-up to a previously sent email referenced by log id
 */
export const getAiDraftFollowUpUrl = () => {
  return `/api/ai/follow-up`;
};

export const aiDraftFollowUp = async (
  aiFollowUpInput: AiFollowUpInput,
  options?: RequestInit,
): Promise<AiFollowUpResponse> => {
  return customFetch<AiFollowUpResponse>(getAiDraftFollowUpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiFollowUpInput),
  });
};

export const getAiDraftFollowUpMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | AiRateLimitError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiDraftFollowUp>>,
    TError,
    { data: BodyType<AiFollowUpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiDraftFollowUp>>,
  TError,
  { data: BodyType<AiFollowUpInput> },
  TContext
> => {
  const mutationKey = ["aiDraftFollowUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiDraftFollowUp>>,
    { data: BodyType<AiFollowUpInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiDraftFollowUp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiDraftFollowUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiDraftFollowUp>>
>;
export type AiDraftFollowUpMutationBody = BodyType<AiFollowUpInput>;
export type AiDraftFollowUpMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | AiRateLimitError
  | ErrorResponse
>;

/**
 * @summary Draft a follow-up to a previously sent email referenced by log id
 */
export const useAiDraftFollowUp = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | AiRateLimitError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiDraftFollowUp>>,
    TError,
    { data: BodyType<AiFollowUpInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiDraftFollowUp>>,
  TError,
  { data: BodyType<AiFollowUpInput> },
  TContext
> => {
  return useMutation(getAiDraftFollowUpMutationOptions(options));
};

/**
 * @summary Send a rendered email through the shared MailCraft Resend sender
 */
export const getSendEmailUrl = () => {
  return `/api/send`;
};

export const sendEmail = async (
  sendEmailInput: SendEmailInput,
  options?: RequestInit,
): Promise<SendEmailResponse> => {
  return customFetch<SendEmailResponse>(getSendEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendEmailInput),
  });
};

export const getSendEmailMutationOptions = <
  TError = ErrorType<
    | ErrorResponse
    | SendValidationError
    | UnauthorizedResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmail>>,
    TError,
    { data: BodyType<SendEmailInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEmail>>,
  TError,
  { data: BodyType<SendEmailInput> },
  TContext
> => {
  const mutationKey = ["sendEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEmail>>,
    { data: BodyType<SendEmailInput> }
  > = (props) => {
    const { data } = props ?? {};

    return sendEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendEmail>>
>;
export type SendEmailMutationBody = BodyType<SendEmailInput>;
export type SendEmailMutationError = ErrorType<
  ErrorResponse | SendValidationError | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Send a rendered email through the shared MailCraft Resend sender
 */
export const useSendEmail = <
  TError = ErrorType<
    | ErrorResponse
    | SendValidationError
    | UnauthorizedResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmail>>,
    TError,
    { data: BodyType<SendEmailInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendEmail>>,
  TError,
  { data: BodyType<SendEmailInput> },
  TContext
> => {
  return useMutation(getSendEmailMutationOptions(options));
};

/**
 * @summary List sent email logs (most recent first)
 */
export const getListEmailLogsUrl = (params?: ListEmailLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/logs?${stringifiedParams}`
    : `/api/logs`;
};

export const listEmailLogs = async (
  params?: ListEmailLogsParams,
  options?: RequestInit,
): Promise<EmailLog[]> => {
  return customFetch<EmailLog[]>(getListEmailLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEmailLogsQueryKey = (params?: ListEmailLogsParams) => {
  return [`/api/logs`, ...(params ? [params] : [])] as const;
};

export const getListEmailLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEmailLogs>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEmailLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEmailLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEmailLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailLogs>>> = ({
    signal,
  }) => listEmailLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEmailLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEmailLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEmailLogs>>
>;
export type ListEmailLogsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List sent email logs (most recent first)
 */

export function useListEmailLogs<
  TData = Awaited<ReturnType<typeof listEmailLogs>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEmailLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEmailLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEmailLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single email log entry (with HTML body)
 */
export const getGetEmailLogUrl = (id: number) => {
  return `/api/logs/${id}`;
};

export const getEmailLog = async (
  id: number,
  options?: RequestInit,
): Promise<EmailLogDetail> => {
  return customFetch<EmailLogDetail>(getGetEmailLogUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetEmailLogQueryKey = (id: number) => {
  return [`/api/logs/${id}`] as const;
};

export const getGetEmailLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmailLog>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEmailLogQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailLog>>> = ({
    signal,
  }) => getEmailLog(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmailLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEmailLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmailLog>>
>;
export type GetEmailLogQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single email log entry (with HTML body)
 */

export function useGetEmailLog<
  TData = Awaited<ReturnType<typeof getEmailLog>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEmailLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEmailLogQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the signed-in user's recorded open + click events from the last 90 days, joined to their `email_logs` row so each entry carries the recipient address and subject. Newest first, paginated via `cursor` (the `nextCursor` returned by the previous page). Each event includes the raw client IP and an approximate location (country + city) resolved at write time via the bundled geoip-lite dataset; for events recorded before that cache existed the location is resolved on the fly from the stored IP, so the UI doesn't have to special-case historical rows. Private / loopback / unresolved IPs surface as `null` country/city.

 * @summary Per-event breakdown of every recorded open / click on the user's recent sends
 */
export const getListEngagementEventsUrl = (
  params?: ListEngagementEventsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/engagement?${stringifiedParams}`
    : `/api/engagement`;
};

export const listEngagementEvents = async (
  params?: ListEngagementEventsParams,
  options?: RequestInit,
): Promise<EngagementEventList> => {
  return customFetch<EngagementEventList>(getListEngagementEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEngagementEventsQueryKey = (
  params?: ListEngagementEventsParams,
) => {
  return [`/api/engagement`, ...(params ? [params] : [])] as const;
};

export const getListEngagementEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEngagementEvents>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEngagementEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEngagementEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEngagementEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEngagementEvents>>
  > = ({ signal }) =>
    listEngagementEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEngagementEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEngagementEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEngagementEvents>>
>;
export type ListEngagementEventsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Per-event breakdown of every recorded open / click on the user's recent sends
 */

export function useListEngagementEvents<
  TData = Awaited<ReturnType<typeof listEngagementEvents>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListEngagementEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEngagementEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEngagementEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Streams every event matching the current filter set as RFC-4180 CSV. By default covers the last 90 days; pass startDate and/or endDate to narrow the window. Same query-param contract as the JSON endpoint (type, hideBots) but ignores limit/cursor so the entire window is exported. The response uses chunked transfer-encoding so large exports don't OOM the server. Returns 400 if startDate or endDate are malformed or if startDate is after endDate.

 * @summary Export engagement events as a streaming CSV download
 */
export const getExportEngagementEventsCsvUrl = (
  params?: ExportEngagementEventsCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/engagement.csv?${stringifiedParams}`
    : `/api/engagement.csv`;
};

export const exportEngagementEventsCsv = async (
  params?: ExportEngagementEventsCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getExportEngagementEventsCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getExportEngagementEventsCsvQueryKey = (
  params?: ExportEngagementEventsCsvParams,
) => {
  return [`/api/engagement.csv`, ...(params ? [params] : [])] as const;
};

export const getExportEngagementEventsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof exportEngagementEventsCsv>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ExportEngagementEventsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportEngagementEventsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportEngagementEventsCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportEngagementEventsCsv>>
  > = ({ signal }) =>
    exportEngagementEventsCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportEngagementEventsCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportEngagementEventsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportEngagementEventsCsv>>
>;
export type ExportEngagementEventsCsvQueryError =
  ErrorType<UnauthorizedResponse>;

/**
 * @summary Export engagement events as a streaming CSV download
 */

export function useExportEngagementEventsCsv<
  TData = Awaited<ReturnType<typeof exportEngagementEventsCsv>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ExportEngagementEventsCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportEngagementEventsCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportEngagementEventsCsvQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * By default returns only active/pending/failed mailboxes — the Brand panel and the inbox sidebar use that filtered view to reflect only the addresses that currently accept new mail. Pass `includeDisabled=true` to also receive soft-deleted mailboxes (status `disabled`); the Brand panel uses this for its "Show removed mailboxes" disclosure so operators can restore an address with one click. Each row carries `messageCount`, the total number of historical inbound messages attached to the mailbox — useful for showing "X messages would re-appear" next to a restore button.

 * @summary List configured inbound mailboxes (sales@, support@) with unread counts
 */
export const getListInboundMailboxesUrl = (
  params?: ListInboundMailboxesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox/mailboxes?${stringifiedParams}`
    : `/api/inbox/mailboxes`;
};

export const listInboundMailboxes = async (
  params?: ListInboundMailboxesParams,
  options?: RequestInit,
): Promise<InboundMailboxList> => {
  return customFetch<InboundMailboxList>(getListInboundMailboxesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInboundMailboxesQueryKey = (
  params?: ListInboundMailboxesParams,
) => {
  return [`/api/inbox/mailboxes`, ...(params ? [params] : [])] as const;
};

export const getListInboundMailboxesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInboundMailboxes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInboundMailboxesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInboundMailboxes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInboundMailboxesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInboundMailboxes>>
  > = ({ signal }) =>
    listInboundMailboxes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInboundMailboxes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInboundMailboxesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInboundMailboxes>>
>;
export type ListInboundMailboxesQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List configured inbound mailboxes (sales@, support@) with unread counts
 */

export function useListInboundMailboxes<
  TData = Awaited<ReturnType<typeof listInboundMailboxes>>,
  TError = ErrorType<UnauthorizedResponse>,
>(
  params?: ListInboundMailboxesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInboundMailboxes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInboundMailboxesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Adds a mailbox at `<localPart>@<inbound domain>`. The local part is validated server-side (alphanumeric plus `._+-`). If a soft-deleted mailbox already exists at the same address it is re-enabled in place (status flipped back to `pending`) so historical messages stay attached. A genuinely active address yields a 409.

 * @summary Add a new inbound mailbox on the configured inbound domain
 */
export const getCreateInboundMailboxUrl = () => {
  return `/api/inbox/mailboxes`;
};

export const createInboundMailbox = async (
  createInboundMailboxInput: CreateInboundMailboxInput,
  options?: RequestInit,
): Promise<InboundMailbox> => {
  return customFetch<InboundMailbox>(getCreateInboundMailboxUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInboundMailboxInput),
  });
};

export const getCreateInboundMailboxMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInboundMailbox>>,
    TError,
    { data: BodyType<CreateInboundMailboxInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInboundMailbox>>,
  TError,
  { data: BodyType<CreateInboundMailboxInput> },
  TContext
> => {
  const mutationKey = ["createInboundMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInboundMailbox>>,
    { data: BodyType<CreateInboundMailboxInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createInboundMailbox(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInboundMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInboundMailbox>>
>;
export type CreateInboundMailboxMutationBody =
  BodyType<CreateInboundMailboxInput>;
export type CreateInboundMailboxMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ConflictResponse
>;

/**
 * @summary Add a new inbound mailbox on the configured inbound domain
 */
export const useCreateInboundMailbox = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInboundMailbox>>,
    TError,
    { data: BodyType<CreateInboundMailboxInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInboundMailbox>>,
  TError,
  { data: BodyType<CreateInboundMailboxInput> },
  TContext
> => {
  return useMutation(getCreateInboundMailboxMutationOptions(options));
};

/**
 * @summary Update an inbound mailbox's display name
 */
export const getUpdateInboundMailboxUrl = (id: number) => {
  return `/api/inbox/mailboxes/${id}`;
};

export const updateInboundMailbox = async (
  id: number,
  updateInboundMailboxInput: UpdateInboundMailboxInput,
  options?: RequestInit,
): Promise<InboundMailbox> => {
  return customFetch<InboundMailbox>(getUpdateInboundMailboxUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateInboundMailboxInput),
  });
};

export const getUpdateInboundMailboxMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInboundMailbox>>,
    TError,
    { id: number; data: BodyType<UpdateInboundMailboxInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInboundMailbox>>,
  TError,
  { id: number; data: BodyType<UpdateInboundMailboxInput> },
  TContext
> => {
  const mutationKey = ["updateInboundMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInboundMailbox>>,
    { id: number; data: BodyType<UpdateInboundMailboxInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateInboundMailbox(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInboundMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInboundMailbox>>
>;
export type UpdateInboundMailboxMutationBody =
  BodyType<UpdateInboundMailboxInput>;
export type UpdateInboundMailboxMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Update an inbound mailbox's display name
 */
export const useUpdateInboundMailbox = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInboundMailbox>>,
    TError,
    { id: number; data: BodyType<UpdateInboundMailboxInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInboundMailbox>>,
  TError,
  { id: number; data: BodyType<UpdateInboundMailboxInput> },
  TContext
> => {
  return useMutation(getUpdateInboundMailboxMutationOptions(options));
};

/**
 * Flips the mailbox's status to `disabled` so the webhook stops accepting new mail addressed to it. Historical inbound messages are intentionally preserved and remain readable from the inbox — only new deliveries are refused.

 * @summary Soft-delete (disable) an inbound mailbox
 */
export const getDeleteInboundMailboxUrl = (id: number) => {
  return `/api/inbox/mailboxes/${id}`;
};

export const deleteInboundMailbox = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteInboundMailboxUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteInboundMailboxMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteInboundMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInboundMailbox>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteInboundMailbox(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteInboundMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInboundMailbox>>
>;

export type DeleteInboundMailboxMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Soft-delete (disable) an inbound mailbox
 */
export const useDeleteInboundMailbox = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInboundMailboxMutationOptions(options));
};

/**
 * Re-enables a mailbox whose status is currently `disabled`. The mailbox keeps its original id, address, and historical inbound messages — only its `status` flips. If the mailbox has ever received mail (i.e. at least one inbound_emails row exists), status goes back to `active`; otherwise it returns to `pending` and waits for the first delivery to flip it to `active`. Calling on a mailbox that isn't disabled returns 409 so the UI can refresh and reflect the current state.

 * @summary Restore a previously soft-deleted inbound mailbox
 */
export const getRestoreInboundMailboxUrl = (id: number) => {
  return `/api/inbox/mailboxes/${id}/restore`;
};

export const restoreInboundMailbox = async (
  id: number,
  options?: RequestInit,
): Promise<InboundMailbox> => {
  return customFetch<InboundMailbox>(getRestoreInboundMailboxUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRestoreInboundMailboxMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["restoreInboundMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreInboundMailbox>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return restoreInboundMailbox(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreInboundMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreInboundMailbox>>
>;

export type RestoreInboundMailboxMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | ConflictResponse
>;

/**
 * @summary Restore a previously soft-deleted inbound mailbox
 */
export const useRestoreInboundMailbox = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | ConflictResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRestoreInboundMailboxMutationOptions(options));
};

/**
 * Hard-deletes a soft-deleted (status = `disabled`) inbound mailbox and its cascaded `inbound_emails` rows. Returns 404 if the mailbox doesn't exist or isn't in the disabled state. The deletion is recorded in the audit log so a forensic trail survives even though the row itself is gone.

 * @summary Permanently delete a disabled inbound mailbox (admin only)
 */
export const getAdminPurgeInboundMailboxUrl = (id: number) => {
  return `/api/admin/inbox/mailboxes/${id}/purge`;
};

export const adminPurgeInboundMailbox = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminPurgeInboundMailboxUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminPurgeInboundMailboxMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPurgeInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminPurgeInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminPurgeInboundMailbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminPurgeInboundMailbox>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminPurgeInboundMailbox(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPurgeInboundMailboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminPurgeInboundMailbox>>
>;

export type AdminPurgeInboundMailboxMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Permanently delete a disabled inbound mailbox (admin only)
 */
export const useAdminPurgeInboundMailbox = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPurgeInboundMailbox>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminPurgeInboundMailbox>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminPurgeInboundMailboxMutationOptions(options));
};

/**
 * Synthesizes a minimal inbound email payload addressed to the given mailbox and runs it through the same persist + threading pipeline live SendGrid Inbound Parse deliveries take. Returns a result object so the operator can confirm the database wiring is in place. Auth wiring (the `SENDGRID_INBOUND_BASIC_AUTH_USER` / `SENDGRID_INBOUND_BASIC_AUTH_PASSWORD` env vars) is reported separately on the diagnostics endpoint via `basicAuthConfigured`.

 * @summary Send a synthetic event through the inbound persist pipeline
 */
export const getTestInboundWebhookUrl = () => {
  return `/api/inbox/test-webhook`;
};

export const testInboundWebhook = async (
  testInboundWebhookInput: TestInboundWebhookInput,
  options?: RequestInit,
): Promise<TestInboundWebhookResult> => {
  return customFetch<TestInboundWebhookResult>(getTestInboundWebhookUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(testInboundWebhookInput),
  });
};

export const getTestInboundWebhookMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testInboundWebhook>>,
    TError,
    { data: BodyType<TestInboundWebhookInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testInboundWebhook>>,
  TError,
  { data: BodyType<TestInboundWebhookInput> },
  TContext
> => {
  const mutationKey = ["testInboundWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testInboundWebhook>>,
    { data: BodyType<TestInboundWebhookInput> }
  > = (props) => {
    const { data } = props ?? {};

    return testInboundWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestInboundWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof testInboundWebhook>>
>;
export type TestInboundWebhookMutationBody = BodyType<TestInboundWebhookInput>;
export type TestInboundWebhookMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Send a synthetic event through the inbound persist pipeline
 */
export const useTestInboundWebhook = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testInboundWebhook>>,
    TError,
    { data: BodyType<TestInboundWebhookInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testInboundWebhook>>,
  TError,
  { data: BodyType<TestInboundWebhookInput> },
  TContext
> => {
  return useMutation(getTestInboundWebhookMutationOptions(options));
};

/**
 * Search across the signed-in user's sent emails (`email_logs`), the workspace's inbound mail (`inbound_emails`, admin-only), and the user's Gmail Primary inbox when connected. Results are merged and ordered by occurredAt DESC and paginated via `limit` + `offset`.
Postgres rows match via a `to_tsvector('simple', ...)` / `websearch_to_tsquery('simple', ...)` predicate backed by expression GIN indexes on both tables, so empty / single-token queries stay sub-500ms even on large mailboxes. Gmail rows come from `messages.list?q=<query>` against the user's own Primary inbox — when Gmail is not connected (or the requested page does not include the Gmail bucket) those rows are simply omitted.
Filters narrow each bucket independently:
  - `direction=sent|inbound|gmail` restricts to that source.
  - `dateFrom` / `dateTo` are ISO timestamps applied to
    `sentAt` (sent), `receivedAt` (inbound), and Gmail's
    `before:` / `after:` qualifiers.
  - `status` and `templateId` only apply to sent results.
  - `hasAttachment=true` only narrows inbound + Gmail rows
    (sent rows do not carry an attachments column).

 * @summary Unified full-text search across sent, inbound, and Gmail mail
 */
export const getSearchEmailsUrl = (params?: SearchEmailsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/search?${stringifiedParams}`
    : `/api/search`;
};

export const searchEmails = async (
  params?: SearchEmailsParams,
  options?: RequestInit,
): Promise<SearchResults> => {
  return customFetch<SearchResults>(getSearchEmailsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchEmailsQueryKey = (params?: SearchEmailsParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getSearchEmailsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchEmails>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: SearchEmailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchEmails>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchEmailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchEmails>>> = ({
    signal,
  }) => searchEmails(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchEmails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchEmailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchEmails>>
>;
export type SearchEmailsQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Unified full-text search across sent, inbound, and Gmail mail
 */

export function useSearchEmails<
  TData = Awaited<ReturnType<typeof searchEmails>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: SearchEmailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchEmails>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchEmailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List inbound emails across all mailboxes (most recent first)
 */
export const getListInboundEmailsUrl = (params?: ListInboundEmailsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox/emails?${stringifiedParams}`
    : `/api/inbox/emails`;
};

export const listInboundEmails = async (
  params?: ListInboundEmailsParams,
  options?: RequestInit,
): Promise<InboundEmailListItem[]> => {
  return customFetch<InboundEmailListItem[]>(getListInboundEmailsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInboundEmailsQueryKey = (
  params?: ListInboundEmailsParams,
) => {
  return [`/api/inbox/emails`, ...(params ? [params] : [])] as const;
};

export const getListInboundEmailsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInboundEmails>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: ListInboundEmailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInboundEmails>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInboundEmailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInboundEmails>>
  > = ({ signal }) => listInboundEmails(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInboundEmails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInboundEmailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInboundEmails>>
>;
export type ListInboundEmailsQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary List inbound emails across all mailboxes (most recent first)
 */

export function useListInboundEmails<
  TData = Awaited<ReturnType<typeof listInboundEmails>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: ListInboundEmailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInboundEmails>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInboundEmailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the count of inbound messages grouped by verification status (`bimi`, `dmarc`, `unverified`, `fail`) over the last N days. Useful for surfacing authentication hygiene insights in the inbox UI.

 * @summary Aggregate verification-status breakdown for inbound messages
 */
export const getGetInboundVerificationStatsUrl = (
  params?: GetInboundVerificationStatsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox/emails/verification-stats?${stringifiedParams}`
    : `/api/inbox/emails/verification-stats`;
};

export const getInboundVerificationStats = async (
  params?: GetInboundVerificationStatsParams,
  options?: RequestInit,
): Promise<InboundVerificationStats> => {
  return customFetch<InboundVerificationStats>(
    getGetInboundVerificationStatsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInboundVerificationStatsQueryKey = (
  params?: GetInboundVerificationStatsParams,
) => {
  return [
    `/api/inbox/emails/verification-stats`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInboundVerificationStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInboundVerificationStats>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: GetInboundVerificationStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundVerificationStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInboundVerificationStatsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInboundVerificationStats>>
  > = ({ signal }) =>
    getInboundVerificationStats(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInboundVerificationStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInboundVerificationStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInboundVerificationStats>>
>;
export type GetInboundVerificationStatsQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Aggregate verification-status breakdown for inbound messages
 */

export function useGetInboundVerificationStats<
  TData = Awaited<ReturnType<typeof getInboundVerificationStats>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: GetInboundVerificationStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundVerificationStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInboundVerificationStatsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns verification-status counts grouped by mailbox for all active mailboxes. Each entry carries the same `breakdown` shape as the single-mailbox endpoint. Designed for the dashboard tiles.

 * @summary Per-mailbox verification-status breakdown
 */
export const getGetInboundVerificationStatsByMailboxUrl = (
  params?: GetInboundVerificationStatsByMailboxParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox/emails/verification-stats-by-mailbox?${stringifiedParams}`
    : `/api/inbox/emails/verification-stats-by-mailbox`;
};

export const getInboundVerificationStatsByMailbox = async (
  params?: GetInboundVerificationStatsByMailboxParams,
  options?: RequestInit,
): Promise<GetInboundVerificationStatsByMailbox200> => {
  return customFetch<GetInboundVerificationStatsByMailbox200>(
    getGetInboundVerificationStatsByMailboxUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInboundVerificationStatsByMailboxQueryKey = (
  params?: GetInboundVerificationStatsByMailboxParams,
) => {
  return [
    `/api/inbox/emails/verification-stats-by-mailbox`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInboundVerificationStatsByMailboxQueryOptions = <
  TData = Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: GetInboundVerificationStatsByMailboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInboundVerificationStatsByMailboxQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>
  > = ({ signal }) =>
    getInboundVerificationStatsByMailbox(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInboundVerificationStatsByMailboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>
>;
export type GetInboundVerificationStatsByMailboxQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Per-mailbox verification-status breakdown
 */

export function useGetInboundVerificationStatsByMailbox<
  TData = Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  params?: GetInboundVerificationStatsByMailboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundVerificationStatsByMailbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInboundVerificationStatsByMailboxQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single inbound email (with full text + HTML body)
 */
export const getGetInboundEmailUrl = (id: number) => {
  return `/api/inbox/emails/${id}`;
};

export const getInboundEmail = async (
  id: number,
  options?: RequestInit,
): Promise<InboundEmailDetail> => {
  return customFetch<InboundEmailDetail>(getGetInboundEmailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInboundEmailQueryKey = (id: number) => {
  return [`/api/inbox/emails/${id}`] as const;
};

export const getGetInboundEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getInboundEmail>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundEmail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInboundEmailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInboundEmail>>> = ({
    signal,
  }) => getInboundEmail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInboundEmail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInboundEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInboundEmail>>
>;
export type GetInboundEmailQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Get a single inbound email (with full text + HTML body)
 */

export function useGetInboundEmail<
  TData = Awaited<ReturnType<typeof getInboundEmail>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInboundEmail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInboundEmailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark an inbound email as read or unread
 */
export const getSetInboundEmailReadStateUrl = (id: number) => {
  return `/api/inbox/emails/${id}/read`;
};

export const setInboundEmailReadState = async (
  id: number,
  setInboundEmailReadStateInput: SetInboundEmailReadStateInput,
  options?: RequestInit,
): Promise<SetInboundEmailReadState200> => {
  return customFetch<SetInboundEmailReadState200>(
    getSetInboundEmailReadStateUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setInboundEmailReadStateInput),
    },
  );
};

export const getSetInboundEmailReadStateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setInboundEmailReadState>>,
    TError,
    { id: number; data: BodyType<SetInboundEmailReadStateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setInboundEmailReadState>>,
  TError,
  { id: number; data: BodyType<SetInboundEmailReadStateInput> },
  TContext
> => {
  const mutationKey = ["setInboundEmailReadState"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setInboundEmailReadState>>,
    { id: number; data: BodyType<SetInboundEmailReadStateInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setInboundEmailReadState(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetInboundEmailReadStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setInboundEmailReadState>>
>;
export type SetInboundEmailReadStateMutationBody =
  BodyType<SetInboundEmailReadStateInput>;
export type SetInboundEmailReadStateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Mark an inbound email as read or unread
 */
export const useSetInboundEmailReadState = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setInboundEmailReadState>>,
    TError,
    { id: number; data: BodyType<SetInboundEmailReadStateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setInboundEmailReadState>>,
  TError,
  { id: number; data: BodyType<SetInboundEmailReadStateInput> },
  TContext
> => {
  return useMutation(getSetInboundEmailReadStateMutationOptions(options));
};

/**
 * Reports whether the signed-in user has signed in via Google and whether their Clerk session has the `gmail.readonly` OAuth scope attached. The MailCraft Inbox page uses this to decide whether to render the Gmail section, the "Connect Gmail" reauthorize prompt, or nothing at all (for users who signed in with email/password and have no Google account linked).

 * @summary Status of the signed-in user's Gmail connection
 */
export const getGetGmailStatusUrl = () => {
  return `/api/inbox/gmail/status`;
};

export const getGmailStatus = async (
  options?: RequestInit,
): Promise<GmailStatus> => {
  return customFetch<GmailStatus>(getGetGmailStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailStatusQueryKey = () => {
  return [`/api/inbox/gmail/status`] as const;
};

export const getGetGmailStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailStatus>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGmailStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmailStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailStatus>>> = ({
    signal,
  }) => getGmailStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailStatus>>
>;
export type GetGmailStatusQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Status of the signed-in user's Gmail connection
 */

export function useGetGmailStatus<
  TData = Awaited<ReturnType<typeof getGmailStatus>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGmailStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the most recent Gmail Primary inbox messages for the signed-in user
 */
export const getListGmailMessagesUrl = (params?: ListGmailMessagesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox/gmail/messages?${stringifiedParams}`
    : `/api/inbox/gmail/messages`;
};

export const listGmailMessages = async (
  params?: ListGmailMessagesParams,
  options?: RequestInit,
): Promise<GmailMessageList> => {
  return customFetch<GmailMessageList>(getListGmailMessagesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListGmailMessagesQueryKey = (
  params?: ListGmailMessagesParams,
) => {
  return [`/api/inbox/gmail/messages`, ...(params ? [params] : [])] as const;
};

export const getListGmailMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listGmailMessages>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
>(
  params?: ListGmailMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGmailMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListGmailMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGmailMessages>>
  > = ({ signal }) => listGmailMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGmailMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGmailMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGmailMessages>>
>;
export type ListGmailMessagesQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary List the most recent Gmail Primary inbox messages for the signed-in user
 */

export function useListGmailMessages<
  TData = Awaited<ReturnType<typeof listGmailMessages>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
>(
  params?: ListGmailMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGmailMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGmailMessagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single Gmail message with full body (read-only)
 */
export const getGetGmailMessageUrl = (id: string) => {
  return `/api/inbox/gmail/messages/${id}`;
};

export const getGmailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<GmailMessageDetail> => {
  return customFetch<GmailMessageDetail>(getGetGmailMessageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailMessageQueryKey = (id: string) => {
  return [`/api/inbox/gmail/messages/${id}`] as const;
};

export const getGetGmailMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailMessage>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GmailUnavailableError
  >,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmailMessageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailMessage>>> = ({
    signal,
  }) => getGmailMessage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailMessage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailMessage>>
>;
export type GetGmailMessageQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | GmailUnavailableError
>;

/**
 * @summary Get a single Gmail message with full body (read-only)
 */

export function useGetGmailMessage<
  TData = Awaited<ReturnType<typeof getGmailMessage>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GmailUnavailableError
  >,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Read-only listing used by the label picker on the message detail page. Requires the `gmail.modify` scope; returns 412 with `reason: "gmail_scope_missing"` if the user is connected but hasn't granted it.

 * @summary List the user's Gmail labels (system + user)
 */
export const getListGmailLabelsUrl = () => {
  return `/api/inbox/gmail/labels`;
};

export const listGmailLabels = async (
  options?: RequestInit,
): Promise<GmailLabelList> => {
  return customFetch<GmailLabelList>(getListGmailLabelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListGmailLabelsQueryKey = () => {
  return [`/api/inbox/gmail/labels`] as const;
};

export const getListGmailLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGmailLabels>>,
  TError = ErrorType<UnauthorizedResponse | GmailUnavailableError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGmailLabels>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGmailLabelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGmailLabels>>> = ({
    signal,
  }) => listGmailLabels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGmailLabels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGmailLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGmailLabels>>
>;
export type ListGmailLabelsQueryError = ErrorType<
  UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary List the user's Gmail labels (system + user)
 */

export function useListGmailLabels<
  TData = Awaited<ReturnType<typeof listGmailLabels>>,
  TError = ErrorType<UnauthorizedResponse | GmailUnavailableError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGmailLabels>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGmailLabelsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a user-type label via Gmail's `labels.create` API so users can spin up new labels from inside MailCraft without leaving for gmail.com. Requires the `gmail.modify` scope; returns 412 with `reason: "gmail_scope_missing"` if the user is connected but hasn't granted it. Returns 409 if Gmail rejects the request because a label with the same name already exists.

 * @summary Create a new user-type Gmail label
 */
export const getCreateGmailLabelUrl = () => {
  return `/api/inbox/gmail/labels`;
};

export const createGmailLabel = async (
  gmailCreateLabelInput: GmailCreateLabelInput,
  options?: RequestInit,
): Promise<GmailLabel> => {
  return customFetch<GmailLabel>(getCreateGmailLabelUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(gmailCreateLabelInput),
  });
};

export const getCreateGmailLabelMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ErrorResponse
    | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGmailLabel>>,
    TError,
    { data: BodyType<GmailCreateLabelInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGmailLabel>>,
  TError,
  { data: BodyType<GmailCreateLabelInput> },
  TContext
> => {
  const mutationKey = ["createGmailLabel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGmailLabel>>,
    { data: BodyType<GmailCreateLabelInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createGmailLabel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGmailLabelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGmailLabel>>
>;
export type CreateGmailLabelMutationBody = BodyType<GmailCreateLabelInput>;
export type CreateGmailLabelMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ErrorResponse
  | GmailUnavailableError
>;

/**
 * @summary Create a new user-type Gmail label
 */
export const useCreateGmailLabel = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ErrorResponse
    | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGmailLabel>>,
    TError,
    { data: BodyType<GmailCreateLabelInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGmailLabel>>,
  TError,
  { data: BodyType<GmailCreateLabelInput> },
  TContext
> => {
  return useMutation(getCreateGmailLabelMutationOptions(options));
};

/**
 * Builds an RFC 5322 multipart/alternative reply (with In-Reply- To and References headers stitched from the inbound message) and sends it via Gmail `messages.send`. Requires the `gmail.send` scope; the inbound `UNREAD` label is also cleared on a best-effort basis once the send succeeds.

 * @summary Send a threaded reply to a Gmail message
 */
export const getReplyToGmailMessageUrl = (id: string) => {
  return `/api/inbox/gmail/messages/${id}/reply`;
};

export const replyToGmailMessage = async (
  id: string,
  gmailReplyInput: GmailReplyInput,
  options?: RequestInit,
): Promise<GmailSendResult> => {
  return customFetch<GmailSendResult>(getReplyToGmailMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(gmailReplyInput),
  });
};

export const getReplyToGmailMessageMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GmailUnavailableError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyToGmailMessage>>,
    TError,
    { id: string; data: BodyType<GmailReplyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replyToGmailMessage>>,
  TError,
  { id: string; data: BodyType<GmailReplyInput> },
  TContext
> => {
  const mutationKey = ["replyToGmailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replyToGmailMessage>>,
    { id: string; data: BodyType<GmailReplyInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return replyToGmailMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplyToGmailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof replyToGmailMessage>>
>;
export type ReplyToGmailMessageMutationBody = BodyType<GmailReplyInput>;
export type ReplyToGmailMessageMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | GmailUnavailableError
  | ErrorResponse
>;

/**
 * @summary Send a threaded reply to a Gmail message
 */
export const useReplyToGmailMessage = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | GmailUnavailableError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyToGmailMessage>>,
    TError,
    { id: string; data: BodyType<GmailReplyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof replyToGmailMessage>>,
  TError,
  { id: string; data: BodyType<GmailReplyInput> },
  TContext
> => {
  return useMutation(getReplyToGmailMessageMutationOptions(options));
};

/**
 * Toggles the `UNREAD` system label. Requires `gmail.modify`.

 * @summary Mark a Gmail message read or unread
 */
export const getSetGmailMessageReadStateUrl = (id: string) => {
  return `/api/inbox/gmail/messages/${id}/read-state`;
};

export const setGmailMessageReadState = async (
  id: string,
  gmailReadStateInput: GmailReadStateInput,
  options?: RequestInit,
): Promise<GmailReadStateResult> => {
  return customFetch<GmailReadStateResult>(getSetGmailMessageReadStateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(gmailReadStateInput),
  });
};

export const getSetGmailMessageReadStateMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGmailMessageReadState>>,
    TError,
    { id: string; data: BodyType<GmailReadStateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setGmailMessageReadState>>,
  TError,
  { id: string; data: BodyType<GmailReadStateInput> },
  TContext
> => {
  const mutationKey = ["setGmailMessageReadState"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setGmailMessageReadState>>,
    { id: string; data: BodyType<GmailReadStateInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setGmailMessageReadState(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetGmailMessageReadStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setGmailMessageReadState>>
>;
export type SetGmailMessageReadStateMutationBody =
  BodyType<GmailReadStateInput>;
export type SetGmailMessageReadStateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary Mark a Gmail message read or unread
 */
export const useSetGmailMessageReadState = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGmailMessageReadState>>,
    TError,
    { id: string; data: BodyType<GmailReadStateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setGmailMessageReadState>>,
  TError,
  { id: string; data: BodyType<GmailReadStateInput> },
  TContext
> => {
  return useMutation(getSetGmailMessageReadStateMutationOptions(options));
};

/**
 * Removes the `INBOX` label, mirroring Gmail's "Archive" action. Requires `gmail.modify`.

 * @summary Archive a Gmail message (remove the INBOX label)
 */
export const getArchiveGmailMessageUrl = (id: string) => {
  return `/api/inbox/gmail/messages/${id}/archive`;
};

export const archiveGmailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<GmailArchiveResult> => {
  return customFetch<GmailArchiveResult>(getArchiveGmailMessageUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getArchiveGmailMessageMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveGmailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveGmailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["archiveGmailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveGmailMessage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return archiveGmailMessage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveGmailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveGmailMessage>>
>;

export type ArchiveGmailMessageMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary Archive a Gmail message (remove the INBOX label)
 */
export const useArchiveGmailMessage = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveGmailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveGmailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getArchiveGmailMessageMutationOptions(options));
};

/**
 * Add and/or remove labels in a single call. Provide one or both of `add` / `remove`. Requires `gmail.modify`.

 * @summary Add and/or remove labels on a Gmail message
 */
export const getModifyGmailMessageLabelsUrl = (id: string) => {
  return `/api/inbox/gmail/messages/${id}/labels`;
};

export const modifyGmailMessageLabels = async (
  id: string,
  gmailLabelsMutation: GmailLabelsMutation,
  options?: RequestInit,
): Promise<GmailLabelsMutationResult> => {
  return customFetch<GmailLabelsMutationResult>(
    getModifyGmailMessageLabelsUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(gmailLabelsMutation),
    },
  );
};

export const getModifyGmailMessageLabelsMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifyGmailMessageLabels>>,
    TError,
    { id: string; data: BodyType<GmailLabelsMutation> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifyGmailMessageLabels>>,
  TError,
  { id: string; data: BodyType<GmailLabelsMutation> },
  TContext
> => {
  const mutationKey = ["modifyGmailMessageLabels"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifyGmailMessageLabels>>,
    { id: string; data: BodyType<GmailLabelsMutation> }
  > = (props) => {
    const { id, data } = props ?? {};

    return modifyGmailMessageLabels(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModifyGmailMessageLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof modifyGmailMessageLabels>>
>;
export type ModifyGmailMessageLabelsMutationBody =
  BodyType<GmailLabelsMutation>;
export type ModifyGmailMessageLabelsMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary Add and/or remove labels on a Gmail message
 */
export const useModifyGmailMessageLabels = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | GmailUnavailableError
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifyGmailMessageLabels>>,
    TError,
    { id: string; data: BodyType<GmailLabelsMutation> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof modifyGmailMessageLabels>>,
  TError,
  { id: string; data: BodyType<GmailLabelsMutation> },
  TContext
> => {
  return useMutation(getModifyGmailMessageLabelsMutationOptions(options));
};

/**
 * Tells Gmail to publish push notifications to the configured Pub/Sub topic each time the user's mailbox changes. Idempotent — calling repeatedly just refreshes the expiry.
Returns `{ "configured": false }` (200) when the `GMAIL_PUBSUB_TOPIC` environment variable is unset on the server. The frontend treats that response as "push isn't wired up yet" and falls back to its 5-minute safety-net poll.

 * @summary Register or refresh the Gmail Pub/Sub watch for the signed-in user
 */
export const getRegisterGmailWatchUrl = () => {
  return `/api/inbox/gmail/watch`;
};

export const registerGmailWatch = async (
  options?: RequestInit,
): Promise<GmailWatchResult> => {
  return customFetch<GmailWatchResult>(getRegisterGmailWatchUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRegisterGmailWatchMutationOptions = <
  TError = ErrorType<UnauthorizedResponse | GmailUnavailableError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerGmailWatch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerGmailWatch>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["registerGmailWatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerGmailWatch>>,
    void
  > = () => {
    return registerGmailWatch(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterGmailWatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerGmailWatch>>
>;

export type RegisterGmailWatchMutationError = ErrorType<
  UnauthorizedResponse | GmailUnavailableError
>;

/**
 * @summary Register or refresh the Gmail Pub/Sub watch for the signed-in user
 */
export const useRegisterGmailWatch = <
  TError = ErrorType<UnauthorizedResponse | GmailUnavailableError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerGmailWatch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerGmailWatch>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRegisterGmailWatchMutationOptions(options));
};

/**
 * Best-effort: stops the upstream Gmail watch (if any) and forgets the persisted watch row. Always returns 200 — calling when no watch exists is a no-op.

 * @summary Cancel the Gmail Pub/Sub watch for the signed-in user
 */
export const getStopGmailWatchUrl = () => {
  return `/api/inbox/gmail/watch`;
};

export const stopGmailWatch = async (
  options?: RequestInit,
): Promise<StopGmailWatch200> => {
  return customFetch<StopGmailWatch200>(getStopGmailWatchUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getStopGmailWatchMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopGmailWatch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stopGmailWatch>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["stopGmailWatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stopGmailWatch>>,
    void
  > = () => {
    return stopGmailWatch(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StopGmailWatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof stopGmailWatch>>
>;

export type StopGmailWatchMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Cancel the Gmail Pub/Sub watch for the signed-in user
 */
export const useStopGmailWatch = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stopGmailWatch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof stopGmailWatch>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getStopGmailWatchMutationOptions(options));
};

/**
 * Updates the signed-in user's productivity state on the given thread. Each field in the body is independent:
  - omitted: leave the column alone.
  - explicit `null`: clear (unpin / unsnooze / cancel reminder).
  - explicit value: set to the supplied value.
Returns the resulting state row.

 * @summary Set or clear the per-user pin/snooze/reminder state on a thread
 */
export const getSetThreadStateUrl = (
  kind: "inbound" | "gmail",
  threadId: string,
) => {
  return `/api/inbox/threads/${kind}/${threadId}/state`;
};

export const setThreadState = async (
  kind: "inbound" | "gmail",
  threadId: string,
  setThreadStateInput: SetThreadStateInput,
  options?: RequestInit,
): Promise<ThreadUserState> => {
  return customFetch<ThreadUserState>(getSetThreadStateUrl(kind, threadId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setThreadStateInput),
  });
};

export const getSetThreadStateMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setThreadState>>,
    TError,
    {
      kind: "inbound" | "gmail";
      threadId: string;
      data: BodyType<SetThreadStateInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setThreadState>>,
  TError,
  {
    kind: "inbound" | "gmail";
    threadId: string;
    data: BodyType<SetThreadStateInput>;
  },
  TContext
> => {
  const mutationKey = ["setThreadState"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setThreadState>>,
    {
      kind: "inbound" | "gmail";
      threadId: string;
      data: BodyType<SetThreadStateInput>;
    }
  > = (props) => {
    const { kind, threadId, data } = props ?? {};

    return setThreadState(kind, threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetThreadStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setThreadState>>
>;
export type SetThreadStateMutationBody = BodyType<SetThreadStateInput>;
export type SetThreadStateMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Set or clear the per-user pin/snooze/reminder state on a thread
 */
export const useSetThreadState = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setThreadState>>,
    TError,
    {
      kind: "inbound" | "gmail";
      threadId: string;
      data: BodyType<SetThreadStateInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setThreadState>>,
  TError,
  {
    kind: "inbound" | "gmail";
    threadId: string;
    data: BodyType<SetThreadStateInput>;
  },
  TContext
> => {
  return useMutation(getSetThreadStateMutationOptions(options));
};

/**
 * Clears the snooze (`snoozedUntil`) and reminder (`reminderAt`, `reminderSetAt`, `reminderFiredAt`) columns on the per-user state row for this thread once the user has seen the resulting badge. Pin state is left untouched.

 * @summary Dismiss the transient "just unsnoozed" / "reminder fired" badges on a thread
 */
export const getDismissThreadFlagsUrl = (
  kind: "inbound" | "gmail",
  threadId: string,
) => {
  return `/api/inbox/threads/${kind}/${threadId}/dismiss-flags`;
};

export const dismissThreadFlags = async (
  kind: "inbound" | "gmail",
  threadId: string,
  options?: RequestInit,
): Promise<ThreadUserState> => {
  return customFetch<ThreadUserState>(
    getDismissThreadFlagsUrl(kind, threadId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDismissThreadFlagsMutationOptions = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissThreadFlags>>,
    TError,
    { kind: "inbound" | "gmail"; threadId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissThreadFlags>>,
  TError,
  { kind: "inbound" | "gmail"; threadId: string },
  TContext
> => {
  const mutationKey = ["dismissThreadFlags"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissThreadFlags>>,
    { kind: "inbound" | "gmail"; threadId: string }
  > = (props) => {
    const { kind, threadId } = props ?? {};

    return dismissThreadFlags(kind, threadId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissThreadFlagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissThreadFlags>>
>;

export type DismissThreadFlagsMutationError = ErrorType<UnauthorizedResponse>;

/**
 * @summary Dismiss the transient "just unsnoozed" / "reminder fired" badges on a thread
 */
export const useDismissThreadFlags = <
  TError = ErrorType<UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissThreadFlags>>,
    TError,
    { kind: "inbound" | "gmail"; threadId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissThreadFlags>>,
  TError,
  { kind: "inbound" | "gmail"; threadId: string },
  TContext
> => {
  return useMutation(getDismissThreadFlagsMutationOptions(options));
};

/**
 * Returns the saved inline-reply draft for the current user on the given inbox or Gmail thread, or `null` when no draft has been saved yet.

 * @summary Load the saved reply draft for the signed-in user on this thread
 */
export const getGetReplyDraftUrl = (kind: "inbound" | "gmail", ref: string) => {
  return `/api/reply-drafts/${kind}/${ref}`;
};

export const getReplyDraft = async (
  kind: "inbound" | "gmail",
  ref: string,
  options?: RequestInit,
): Promise<ReplyDraft | null> => {
  return customFetch<ReplyDraft | null>(getGetReplyDraftUrl(kind, ref), {
    ...options,
    method: "GET",
  });
};

export const getGetReplyDraftQueryKey = (
  kind: "inbound" | "gmail",
  ref: string,
) => {
  return [`/api/reply-drafts/${kind}/${ref}`] as const;
};

export const getGetReplyDraftQueryOptions = <
  TData = Awaited<ReturnType<typeof getReplyDraft>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  kind: "inbound" | "gmail",
  ref: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReplyDraft>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReplyDraftQueryKey(kind, ref);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReplyDraft>>> = ({
    signal,
  }) => getReplyDraft(kind, ref, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(kind && ref),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReplyDraft>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReplyDraftQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReplyDraft>>
>;
export type GetReplyDraftQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Load the saved reply draft for the signed-in user on this thread
 */

export function useGetReplyDraft<
  TData = Awaited<ReturnType<typeof getReplyDraft>>,
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
>(
  kind: "inbound" | "gmail",
  ref: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReplyDraft>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReplyDraftQueryOptions(kind, ref, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Upserts the inline-reply draft on the user's behalf. The client debounces edits and re-PUTs the full subject/body so the server side stays simple. Returns the saved draft.

 * @summary Insert or update the reply draft for this thread
 */
export const getSaveReplyDraftUrl = (
  kind: "inbound" | "gmail",
  ref: string,
) => {
  return `/api/reply-drafts/${kind}/${ref}`;
};

export const saveReplyDraft = async (
  kind: "inbound" | "gmail",
  ref: string,
  saveReplyDraftInput: SaveReplyDraftInput,
  options?: RequestInit,
): Promise<ReplyDraft> => {
  return customFetch<ReplyDraft>(getSaveReplyDraftUrl(kind, ref), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveReplyDraftInput),
  });
};

export const getSaveReplyDraftMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveReplyDraft>>,
    TError,
    {
      kind: "inbound" | "gmail";
      ref: string;
      data: BodyType<SaveReplyDraftInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveReplyDraft>>,
  TError,
  {
    kind: "inbound" | "gmail";
    ref: string;
    data: BodyType<SaveReplyDraftInput>;
  },
  TContext
> => {
  const mutationKey = ["saveReplyDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveReplyDraft>>,
    {
      kind: "inbound" | "gmail";
      ref: string;
      data: BodyType<SaveReplyDraftInput>;
    }
  > = (props) => {
    const { kind, ref, data } = props ?? {};

    return saveReplyDraft(kind, ref, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveReplyDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveReplyDraft>>
>;
export type SaveReplyDraftMutationBody = BodyType<SaveReplyDraftInput>;
export type SaveReplyDraftMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Insert or update the reply draft for this thread
 */
export const useSaveReplyDraft = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveReplyDraft>>,
    TError,
    {
      kind: "inbound" | "gmail";
      ref: string;
      data: BodyType<SaveReplyDraftInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveReplyDraft>>,
  TError,
  {
    kind: "inbound" | "gmail";
    ref: string;
    data: BodyType<SaveReplyDraftInput>;
  },
  TContext
> => {
  return useMutation(getSaveReplyDraftMutationOptions(options));
};

/**
 * Removes the saved inline-reply draft. Called after the user sends the reply or explicitly discards the draft. Idempotent — returns 204 even when no draft existed.

 * @summary Delete the saved reply draft for this thread
 */
export const getDeleteReplyDraftUrl = (
  kind: "inbound" | "gmail",
  ref: string,
) => {
  return `/api/reply-drafts/${kind}/${ref}`;
};

export const deleteReplyDraft = async (
  kind: "inbound" | "gmail",
  ref: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteReplyDraftUrl(kind, ref), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteReplyDraftMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReplyDraft>>,
    TError,
    { kind: "inbound" | "gmail"; ref: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReplyDraft>>,
  TError,
  { kind: "inbound" | "gmail"; ref: string },
  TContext
> => {
  const mutationKey = ["deleteReplyDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReplyDraft>>,
    { kind: "inbound" | "gmail"; ref: string }
  > = (props) => {
    const { kind, ref } = props ?? {};

    return deleteReplyDraft(kind, ref, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReplyDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReplyDraft>>
>;

export type DeleteReplyDraftMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Delete the saved reply draft for this thread
 */
export const useDeleteReplyDraft = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReplyDraft>>,
    TError,
    { kind: "inbound" | "gmail"; ref: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReplyDraft>>,
  TError,
  { kind: "inbound" | "gmail"; ref: string },
  TContext
> => {
  return useMutation(getDeleteReplyDraftMutationOptions(options));
};

/**
 * @summary Generate an AI-drafted reply to an inbound email (never sent automatically)
 */
export const getAiReplyDraftUrl = () => {
  return `/api/ai/reply-draft`;
};

export const aiReplyDraft = async (
  aiReplyDraftInput: AiReplyDraftInput,
  options?: RequestInit,
): Promise<AiReplyDraft> => {
  return customFetch<AiReplyDraft>(getAiReplyDraftUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(aiReplyDraftInput),
  });
};

export const getAiReplyDraftMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | AiRateLimitError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiReplyDraft>>,
    TError,
    { data: BodyType<AiReplyDraftInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof aiReplyDraft>>,
  TError,
  { data: BodyType<AiReplyDraftInput> },
  TContext
> => {
  const mutationKey = ["aiReplyDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof aiReplyDraft>>,
    { data: BodyType<AiReplyDraftInput> }
  > = (props) => {
    const { data } = props ?? {};

    return aiReplyDraft(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AiReplyDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof aiReplyDraft>>
>;
export type AiReplyDraftMutationBody = BodyType<AiReplyDraftInput>;
export type AiReplyDraftMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | NotFoundResponse
  | AiRateLimitError
  | ErrorResponse
>;

/**
 * @summary Generate an AI-drafted reply to an inbound email (never sent automatically)
 */
export const useAiReplyDraft = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | NotFoundResponse
    | AiRateLimitError
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof aiReplyDraft>>,
    TError,
    { data: BodyType<AiReplyDraftInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof aiReplyDraft>>,
  TError,
  { data: BodyType<AiReplyDraftInput> },
  TContext
> => {
  return useMutation(getAiReplyDraftMutationOptions(options));
};

/**
 * @summary List users (admin only)
 */
export const getAdminListUsersUrl = (params?: AdminListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/users?${stringifiedParams}`
    : `/api/admin/users`;
};

export const adminListUsers = async (
  params?: AdminListUsersParams,
  options?: RequestInit,
): Promise<AdminUserList> => {
  return customFetch<AdminUserList>(getAdminListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListUsersQueryKey = (params?: AdminListUsersParams) => {
  return [`/api/admin/users`, ...(params ? [params] : [])] as const;
};

export const getAdminListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ErrorResponse>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUsers>>> = ({
    signal,
  }) => adminListUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUsers>>
>;
export type AdminListUsersQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | ErrorResponse
>;

/**
 * @summary List users (admin only)
 */

export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse | ErrorResponse>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new user (admin only)
 */
export const getAdminCreateUserUrl = () => {
  return `/api/admin/users`;
};

export const adminCreateUser = async (
  adminCreateUserInput: AdminCreateUserInput,
  options?: RequestInit,
): Promise<AdminUser> => {
  return customFetch<AdminUser>(getAdminCreateUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminCreateUserInput),
  });
};

export const getAdminCreateUserMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateUser>>,
    TError,
    { data: BodyType<AdminCreateUserInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateUser>>,
  TError,
  { data: BodyType<AdminCreateUserInput> },
  TContext
> => {
  const mutationKey = ["adminCreateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateUser>>,
    { data: BodyType<AdminCreateUserInput> }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateUser>>
>;
export type AdminCreateUserMutationBody = BodyType<AdminCreateUserInput>;
export type AdminCreateUserMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Create a new user (admin only)
 */
export const useAdminCreateUser = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateUser>>,
    TError,
    { data: BodyType<AdminCreateUserInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateUser>>,
  TError,
  { data: BodyType<AdminCreateUserInput> },
  TContext
> => {
  return useMutation(getAdminCreateUserMutationOptions(options));
};

/**
 * @summary Permanently delete selected non-admin accounts
 */
export const getAdminBulkDeleteUsersUrl = () => {
  return `/api/admin/users/bulk-delete`;
};

export const adminBulkDeleteUsers = async (
  adminBulkDeleteInput: AdminBulkDeleteInput,
  options?: RequestInit,
): Promise<AdminBulkDeleteUsers200> => {
  return customFetch<AdminBulkDeleteUsers200>(getAdminBulkDeleteUsersUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminBulkDeleteInput),
  });
};

export const getAdminBulkDeleteUsersMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBulkDeleteUsers>>,
    TError,
    { data: BodyType<AdminBulkDeleteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminBulkDeleteUsers>>,
  TError,
  { data: BodyType<AdminBulkDeleteInput> },
  TContext
> => {
  const mutationKey = ["adminBulkDeleteUsers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminBulkDeleteUsers>>,
    { data: BodyType<AdminBulkDeleteInput> }
  > = (props) => {
    const { data } = props ?? {};

    return adminBulkDeleteUsers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBulkDeleteUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminBulkDeleteUsers>>
>;
export type AdminBulkDeleteUsersMutationBody = BodyType<AdminBulkDeleteInput>;
export type AdminBulkDeleteUsersMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Permanently delete selected non-admin accounts
 */
export const useAdminBulkDeleteUsers = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBulkDeleteUsers>>,
    TError,
    { data: BodyType<AdminBulkDeleteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminBulkDeleteUsers>>,
  TError,
  { data: BodyType<AdminBulkDeleteInput> },
  TContext
> => {
  return useMutation(getAdminBulkDeleteUsersMutationOptions(options));
};

/**
 * @summary Transfer source account data into an existing destination account
 */
export const getAdminMergeUsersUrl = (clerkUserId: string) => {
  return `/api/admin/users/${clerkUserId}/merge`;
};

export const adminMergeUsers = async (
  clerkUserId: string,
  adminMergeInput: AdminMergeInput,
  options?: RequestInit,
): Promise<AdminMergeUsers200> => {
  return customFetch<AdminMergeUsers200>(getAdminMergeUsersUrl(clerkUserId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminMergeInput),
  });
};

export const getAdminMergeUsersMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMergeUsers>>,
    TError,
    { clerkUserId: string; data: BodyType<AdminMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMergeUsers>>,
  TError,
  { clerkUserId: string; data: BodyType<AdminMergeInput> },
  TContext
> => {
  const mutationKey = ["adminMergeUsers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMergeUsers>>,
    { clerkUserId: string; data: BodyType<AdminMergeInput> }
  > = (props) => {
    const { clerkUserId, data } = props ?? {};

    return adminMergeUsers(clerkUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMergeUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMergeUsers>>
>;
export type AdminMergeUsersMutationBody = BodyType<AdminMergeInput>;
export type AdminMergeUsersMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ErrorResponse
>;

/**
 * @summary Transfer source account data into an existing destination account
 */
export const useAdminMergeUsers = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMergeUsers>>,
    TError,
    { clerkUserId: string; data: BodyType<AdminMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminMergeUsers>>,
  TError,
  { clerkUserId: string; data: BodyType<AdminMergeInput> },
  TContext
> => {
  return useMutation(getAdminMergeUsersMutationOptions(options));
};

/**
 * @summary Update a user's profile or admin flag (admin only)
 */
export const getAdminUpdateUserUrl = (clerkUserId: string) => {
  return `/api/admin/users/${clerkUserId}`;
};

export const adminUpdateUser = async (
  clerkUserId: string,
  adminUpdateUserInput: AdminUpdateUserInput,
  options?: RequestInit,
): Promise<AdminUser> => {
  return customFetch<AdminUser>(getAdminUpdateUserUrl(clerkUserId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminUpdateUserInput),
  });
};

export const getAdminUpdateUserMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateUser>>,
    TError,
    { clerkUserId: string; data: BodyType<AdminUpdateUserInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateUser>>,
  TError,
  { clerkUserId: string; data: BodyType<AdminUpdateUserInput> },
  TContext
> => {
  const mutationKey = ["adminUpdateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateUser>>,
    { clerkUserId: string; data: BodyType<AdminUpdateUserInput> }
  > = (props) => {
    const { clerkUserId, data } = props ?? {};

    return adminUpdateUser(clerkUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateUser>>
>;
export type AdminUpdateUserMutationBody = BodyType<AdminUpdateUserInput>;
export type AdminUpdateUserMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Update a user's profile or admin flag (admin only)
 */
export const useAdminUpdateUser = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateUser>>,
    TError,
    { clerkUserId: string; data: BodyType<AdminUpdateUserInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateUser>>,
  TError,
  { clerkUserId: string; data: BodyType<AdminUpdateUserInput> },
  TContext
> => {
  return useMutation(getAdminUpdateUserMutationOptions(options));
};

/**
 * Removes the Clerk account and all locally-owned data (templates, contacts, brand settings, rep defaults, send logs) via cascading foreign keys. Refuses to delete the signed-in admin's own account.

 * @summary Delete a user from Clerk and the local DB (admin only)
 */
export const getAdminDeleteUserUrl = (clerkUserId: string) => {
  return `/api/admin/users/${clerkUserId}`;
};

export const adminDeleteUser = async (
  clerkUserId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminDeleteUserUrl(clerkUserId), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminDeleteUserMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteUser>>,
    TError,
    { clerkUserId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteUser>>,
  TError,
  { clerkUserId: string },
  TContext
> => {
  const mutationKey = ["adminDeleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteUser>>,
    { clerkUserId: string }
  > = (props) => {
    const { clerkUserId } = props ?? {};

    return adminDeleteUser(clerkUserId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteUser>>
>;

export type AdminDeleteUserMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ErrorResponse
>;

/**
 * @summary Delete a user from Clerk and the local DB (admin only)
 */
export const useAdminDeleteUser = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteUser>>,
    TError,
    { clerkUserId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteUser>>,
  TError,
  { clerkUserId: string },
  TContext
> => {
  return useMutation(getAdminDeleteUserMutationOptions(options));
};

/**
 * Returns audit-log entries newest-first, optionally filtered by actor, event type, target, free-text search, and time window. Filters compose with AND. Pagination via `limit` + `offset`.

 * @summary List audit-log events (admin only)
 */
export const getAdminListAuditLogUrl = (params?: AdminListAuditLogParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/audit-log?${stringifiedParams}`
    : `/api/admin/audit-log`;
};

export const adminListAuditLog = async (
  params?: AdminListAuditLogParams,
  options?: RequestInit,
): Promise<AuditLogList> => {
  return customFetch<AuditLogList>(getAdminListAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListAuditLogQueryKey = (
  params?: AdminListAuditLogParams,
) => {
  return [`/api/admin/audit-log`, ...(params ? [params] : [])] as const;
};

export const getAdminListAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAuditLog>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListAuditLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListAuditLog>>
  > = ({ signal }) => adminListAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListAuditLog>>
>;
export type AdminListAuditLogQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary List audit-log events (admin only)
 */

export function useAdminListAuditLog<
  TData = Awaited<ReturnType<typeof adminListAuditLog>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminListAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns, for the given UTC date window, every allowlisted user with their per-template send counts plus a queued-in-window count and overall total. Failed sends are excluded; queued sends are reported separately so totals reflect "in flight" volume. Test-kind sends are excluded by default.

 * @summary Per-agent × template send-volume report (admin only)
 */
export const getAdminGetEmailVolumeUrl = (
  params?: AdminGetEmailVolumeParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics/email-volume?${stringifiedParams}`
    : `/api/admin/analytics/email-volume`;
};

export const adminGetEmailVolume = async (
  params?: AdminGetEmailVolumeParams,
  options?: RequestInit,
): Promise<EmailVolumeReport> => {
  return customFetch<EmailVolumeReport>(getAdminGetEmailVolumeUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetEmailVolumeQueryKey = (
  params?: AdminGetEmailVolumeParams,
) => {
  return [
    `/api/admin/analytics/email-volume`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetEmailVolumeQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetEmailVolume>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminGetEmailVolumeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolume>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetEmailVolumeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetEmailVolume>>
  > = ({ signal }) =>
    adminGetEmailVolume(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetEmailVolume>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetEmailVolumeQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetEmailVolume>>
>;
export type AdminGetEmailVolumeQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary Per-agent × template send-volume report (admin only)
 */

export function useAdminGetEmailVolume<
  TData = Awaited<ReturnType<typeof adminGetEmailVolume>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminGetEmailVolumeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolume>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetEmailVolumeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-template + daily breakdown for one agent (admin only)
 */
export const getAdminGetEmailVolumeForUserUrl = (
  params: AdminGetEmailVolumeForUserParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics/email-volume/agent?${stringifiedParams}`
    : `/api/admin/analytics/email-volume/agent`;
};

export const adminGetEmailVolumeForUser = async (
  params: AdminGetEmailVolumeForUserParams,
  options?: RequestInit,
): Promise<EmailVolumeAgentDetail> => {
  return customFetch<EmailVolumeAgentDetail>(
    getAdminGetEmailVolumeForUserUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetEmailVolumeForUserQueryKey = (
  params?: AdminGetEmailVolumeForUserParams,
) => {
  return [
    `/api/admin/analytics/email-volume/agent`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetEmailVolumeForUserQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
>(
  params: AdminGetEmailVolumeForUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetEmailVolumeForUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>
  > = ({ signal }) =>
    adminGetEmailVolumeForUser(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetEmailVolumeForUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>
>;
export type AdminGetEmailVolumeForUserQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Per-template + daily breakdown for one agent (admin only)
 */

export function useAdminGetEmailVolumeForUser<
  TData = Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
>(
  params: AdminGetEmailVolumeForUserParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolumeForUser>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetEmailVolumeForUserQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary CSV export of the per-agent send-volume report (admin only)
 */
export const getAdminGetEmailVolumeCsvUrl = (
  params?: AdminGetEmailVolumeCsvParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics/email-volume.csv?${stringifiedParams}`
    : `/api/admin/analytics/email-volume.csv`;
};

export const adminGetEmailVolumeCsv = async (
  params?: AdminGetEmailVolumeCsvParams,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getAdminGetEmailVolumeCsvUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetEmailVolumeCsvQueryKey = (
  params?: AdminGetEmailVolumeCsvParams,
) => {
  return [
    `/api/admin/analytics/email-volume.csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetEmailVolumeCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminGetEmailVolumeCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetEmailVolumeCsvQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>
  > = ({ signal }) =>
    adminGetEmailVolumeCsv(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetEmailVolumeCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>
>;
export type AdminGetEmailVolumeCsvQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary CSV export of the per-agent send-volume report (admin only)
 */

export function useAdminGetEmailVolumeCsv<
  TData = Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse
  >,
>(
  params?: AdminGetEmailVolumeCsvParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetEmailVolumeCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetEmailVolumeCsvQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns persisted Pub/Sub rate-limit burst alerts newest-first. Each entry records a detected burst of IP flood or messageId replay events, including the count, top IPs, and time window.

 * @summary List rate-limit alert history (admin only)
 */
export const getAdminListRateLimitAlertsUrl = (
  params?: AdminListRateLimitAlertsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/rate-limit-alerts?${stringifiedParams}`
    : `/api/admin/rate-limit-alerts`;
};

export const adminListRateLimitAlerts = async (
  params?: AdminListRateLimitAlertsParams,
  options?: RequestInit,
): Promise<RateLimitAlertList> => {
  return customFetch<RateLimitAlertList>(
    getAdminListRateLimitAlertsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListRateLimitAlertsQueryKey = (
  params?: AdminListRateLimitAlertsParams,
) => {
  return [`/api/admin/rate-limit-alerts`, ...(params ? [params] : [])] as const;
};

export const getAdminListRateLimitAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListRateLimitAlerts>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
>(
  params?: AdminListRateLimitAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListRateLimitAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListRateLimitAlertsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListRateLimitAlerts>>
  > = ({ signal }) =>
    adminListRateLimitAlerts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListRateLimitAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListRateLimitAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListRateLimitAlerts>>
>;
export type AdminListRateLimitAlertsQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary List rate-limit alert history (admin only)
 */

export function useAdminListRateLimitAlerts<
  TData = Awaited<ReturnType<typeof adminListRateLimitAlerts>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
>(
  params?: AdminListRateLimitAlertsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListRateLimitAlerts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListRateLimitAlertsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns every user-owned template currently in the Trash (`deletedAt IS NOT NULL`), regardless of owner, with the owning user's identifying info attached so the admin can tell whose template they're about to restore. Built-in templates are never included. Most recently deleted first.

 * @summary List trashed user templates across every account (admin only)
 */
export const getAdminListTrashedTemplatesUrl = (
  params?: AdminListTrashedTemplatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/templates/trash?${stringifiedParams}`
    : `/api/admin/templates/trash`;
};

export const adminListTrashedTemplates = async (
  params?: AdminListTrashedTemplatesParams,
  options?: RequestInit,
): Promise<AdminTrashedTemplateList> => {
  return customFetch<AdminTrashedTemplateList>(
    getAdminListTrashedTemplatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListTrashedTemplatesQueryKey = (
  params?: AdminListTrashedTemplatesParams,
) => {
  return [`/api/admin/templates/trash`, ...(params ? [params] : [])] as const;
};

export const getAdminListTrashedTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListTrashedTemplates>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
>(
  params?: AdminListTrashedTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListTrashedTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListTrashedTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListTrashedTemplates>>
  > = ({ signal }) =>
    adminListTrashedTemplates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListTrashedTemplates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListTrashedTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListTrashedTemplates>>
>;
export type AdminListTrashedTemplatesQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse
>;

/**
 * @summary List trashed user templates across every account (admin only)
 */

export function useAdminListTrashedTemplates<
  TData = Awaited<ReturnType<typeof adminListTrashedTemplates>>,
  TError = ErrorType<UnauthorizedResponse | ForbiddenResponse>,
>(
  params?: AdminListTrashedTemplatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListTrashedTemplates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListTrashedTemplatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Clears `deletedAt` on a soft-deleted user template, even if the admin is not the template's owner. If the original slug now collides with another active template owned by the same user (because they created a new one with the same name while this was in the Trash), the restored template's slug is auto-suffixed the same way `POST /templates/{id}/restore` handles owner self- restore.

 * @summary Restore any user's trashed template on their behalf (admin only)
 */
export const getAdminRestoreTemplateUrl = (id: number) => {
  return `/api/admin/templates/${id}/restore`;
};

export const adminRestoreTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<Template> => {
  return customFetch<Template>(getAdminRestoreTemplateUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminRestoreTemplateMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRestoreTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminRestoreTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRestoreTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminRestoreTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRestoreTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRestoreTemplate>>
>;

export type AdminRestoreTemplateMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | ErrorResponse
>;

/**
 * @summary Restore any user's trashed template on their behalf (admin only)
 */
export const useAdminRestoreTemplate = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRestoreTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRestoreTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminRestoreTemplateMutationOptions(options));
};

/**
 * Hard-deletes a soft-deleted user template, regardless of owner. The template must currently be in the Trash (`deletedAt IS NOT NULL`). Admins cannot purge built-in templates here — use the normal hide flow for those.

 * @summary Permanently delete any user's trashed template (admin only)
 */
export const getAdminPurgeTemplateUrl = (id: number) => {
  return `/api/admin/templates/${id}/purge`;
};

export const adminPurgeTemplate = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getAdminPurgeTemplateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminPurgeTemplateMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPurgeTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminPurgeTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["adminPurgeTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminPurgeTemplate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return adminPurgeTemplate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPurgeTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminPurgeTemplate>>
>;

export type AdminPurgeTemplateMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
>;

/**
 * @summary Permanently delete any user's trashed template (admin only)
 */
export const useAdminPurgeTemplate = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPurgeTemplate>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminPurgeTemplate>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getAdminPurgeTemplateMutationOptions(options));
};

/**
 * @summary List the current user's outbound webhook endpoints
 */
export const getListWebhookEndpointsUrl = () => {
  return `/api/webhooks/endpoints`;
};

export const listWebhookEndpoints = async (
  options?: RequestInit,
): Promise<WebhookEndpointList> => {
  return customFetch<WebhookEndpointList>(getListWebhookEndpointsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListWebhookEndpointsQueryKey = () => {
  return [`/api/webhooks/endpoints`] as const;
};

export const getListWebhookEndpointsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWebhookEndpoints>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookEndpoints>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWebhookEndpointsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWebhookEndpoints>>
  > = ({ signal }) => listWebhookEndpoints({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookEndpoints>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWebhookEndpointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWebhookEndpoints>>
>;
export type ListWebhookEndpointsQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the current user's outbound webhook endpoints
 */

export function useListWebhookEndpoints<
  TData = Awaited<ReturnType<typeof listWebhookEndpoints>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookEndpoints>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWebhookEndpointsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Generates a fresh signing secret and returns it in plaintext exactly once on this response. The secret is never re-revealed by the API; users must save it on creation. The hashed + encrypted forms are persisted; the plaintext is used by the delivery worker to HMAC-sign every outgoing payload.

 * @summary Register a new outbound webhook endpoint
 */
export const getCreateWebhookEndpointUrl = () => {
  return `/api/webhooks/endpoints`;
};

export const createWebhookEndpoint = async (
  createWebhookEndpointInput: CreateWebhookEndpointInput,
  options?: RequestInit,
): Promise<CreateWebhookEndpointResult> => {
  return customFetch<CreateWebhookEndpointResult>(
    getCreateWebhookEndpointUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createWebhookEndpointInput),
    },
  );
};

export const getCreateWebhookEndpointMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    TError,
    { data: BodyType<CreateWebhookEndpointInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWebhookEndpoint>>,
  TError,
  { data: BodyType<CreateWebhookEndpointInput> },
  TContext
> => {
  const mutationKey = ["createWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    { data: BodyType<CreateWebhookEndpointInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createWebhookEndpoint(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWebhookEndpoint>>
>;
export type CreateWebhookEndpointMutationBody =
  BodyType<CreateWebhookEndpointInput>;
export type CreateWebhookEndpointMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Register a new outbound webhook endpoint
 */
export const useCreateWebhookEndpoint = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWebhookEndpoint>>,
    TError,
    { data: BodyType<CreateWebhookEndpointInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWebhookEndpoint>>,
  TError,
  { data: BodyType<CreateWebhookEndpointInput> },
  TContext
> => {
  return useMutation(getCreateWebhookEndpointMutationOptions(options));
};

/**
 * @summary Update a webhook endpoint's URL, subscribed event types, or active flag
 */
export const getUpdateWebhookEndpointUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}`;
};

export const updateWebhookEndpoint = async (
  id: number,
  updateWebhookEndpointInput: UpdateWebhookEndpointInput,
  options?: RequestInit,
): Promise<WebhookEndpointEnvelope> => {
  return customFetch<WebhookEndpointEnvelope>(getUpdateWebhookEndpointUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWebhookEndpointInput),
  });
};

export const getUpdateWebhookEndpointMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    TError,
    { id: number; data: BodyType<UpdateWebhookEndpointInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>,
  TError,
  { id: number; data: BodyType<UpdateWebhookEndpointInput> },
  TContext
> => {
  const mutationKey = ["updateWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    { id: number; data: BodyType<UpdateWebhookEndpointInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWebhookEndpoint(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>
>;
export type UpdateWebhookEndpointMutationBody =
  BodyType<UpdateWebhookEndpointInput>;
export type UpdateWebhookEndpointMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Update a webhook endpoint's URL, subscribed event types, or active flag
 */
export const useUpdateWebhookEndpoint = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWebhookEndpoint>>,
    TError,
    { id: number; data: BodyType<UpdateWebhookEndpointInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWebhookEndpoint>>,
  TError,
  { id: number; data: BodyType<UpdateWebhookEndpointInput> },
  TContext
> => {
  return useMutation(getUpdateWebhookEndpointMutationOptions(options));
};

/**
 * @summary Delete a webhook endpoint and all of its delivery history
 */
export const getDeleteWebhookEndpointUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}`;
};

export const deleteWebhookEndpoint = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteWebhookEndpointUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteWebhookEndpointMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteWebhookEndpoint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWebhookEndpoint(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWebhookEndpointMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>
>;

export type DeleteWebhookEndpointMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Delete a webhook endpoint and all of its delivery history
 */
export const useDeleteWebhookEndpoint = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWebhookEndpoint>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteWebhookEndpointMutationOptions(options));
};

/**
 * Replaces the endpoint's signing secret with a freshly generated `whsec_…` value, returning the new plaintext exactly once on this response. After rotation the old secret immediately stops verifying. Use this when a secret is suspected to have leaked or as part of regular key hygiene.

 * @summary Generate a fresh signing secret for an existing endpoint
 */
export const getRotateWebhookEndpointSecretUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}/rotate-secret`;
};

export const rotateWebhookEndpointSecret = async (
  id: number,
  options?: RequestInit,
): Promise<CreateWebhookEndpointResult> => {
  return customFetch<CreateWebhookEndpointResult>(
    getRotateWebhookEndpointSecretUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRotateWebhookEndpointSecretMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["rotateWebhookEndpointSecret"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return rotateWebhookEndpointSecret(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RotateWebhookEndpointSecretMutationResult = NonNullable<
  Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>
>;

export type RotateWebhookEndpointSecretMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Generate a fresh signing secret for an existing endpoint
 */
export const useRotateWebhookEndpointSecret = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rotateWebhookEndpointSecret>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRotateWebhookEndpointSecretMutationOptions(options));
};

/**
 * Creates a signed `webhook.test` delivery for the given endpoint and enqueues it immediately. The delivery appears in the deliveries log with the same retry / dead-letter behaviour as real events, so users can verify their subscriber is reachable and correctly verifying signatures without waiting for a real email event.

 * @summary Send a synthetic webhook.test event to confirm the endpoint works
 */
export const getSendWebhookTestEventUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}/test`;
};

export const sendWebhookTestEvent = async (
  id: number,
  options?: RequestInit,
): Promise<WebhookTestResult> => {
  return customFetch<WebhookTestResult>(getSendWebhookTestEventUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendWebhookTestEventMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendWebhookTestEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendWebhookTestEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendWebhookTestEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendWebhookTestEvent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendWebhookTestEvent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendWebhookTestEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendWebhookTestEvent>>
>;

export type SendWebhookTestEventMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Send a synthetic webhook.test event to confirm the endpoint works
 */
export const useSendWebhookTestEvent = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendWebhookTestEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendWebhookTestEvent>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendWebhookTestEventMutationOptions(options));
};

/**
 * @summary List the 50 most recent delivery attempts for an endpoint (newest first)
 */
export const getListWebhookDeliveriesUrl = (id: number) => {
  return `/api/webhooks/endpoints/${id}/deliveries`;
};

export const listWebhookDeliveries = async (
  id: number,
  options?: RequestInit,
): Promise<WebhookDeliveryList> => {
  return customFetch<WebhookDeliveryList>(getListWebhookDeliveriesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListWebhookDeliveriesQueryKey = (id: number) => {
  return [`/api/webhooks/endpoints/${id}/deliveries`] as const;
};

export const getListWebhookDeliveriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWebhookDeliveries>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWebhookDeliveries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWebhookDeliveriesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWebhookDeliveries>>
  > = ({ signal }) => listWebhookDeliveries(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookDeliveries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWebhookDeliveriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWebhookDeliveries>>
>;
export type ListWebhookDeliveriesQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary List the 50 most recent delivery attempts for an endpoint (newest first)
 */

export function useListWebhookDeliveries<
  TData = Awaited<ReturnType<typeof listWebhookDeliveries>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWebhookDeliveries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWebhookDeliveriesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Resets the attempt counter on the chosen delivery row and re-enqueues it for the worker to retry. Reuses the original event id so consumers can deduplicate against their first attempt.

 * @summary Re-attempt a previous webhook delivery
 */
export const getRedeliverWebhookDeliveryUrl = (id: number) => {
  return `/api/webhooks/deliveries/${id}/redeliver`;
};

export const redeliverWebhookDelivery = async (
  id: number,
  options?: RequestInit,
): Promise<WebhookRedeliverResult> => {
  return customFetch<WebhookRedeliverResult>(
    getRedeliverWebhookDeliveryUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRedeliverWebhookDeliveryMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redeliverWebhookDelivery>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redeliverWebhookDelivery>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["redeliverWebhookDelivery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redeliverWebhookDelivery>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return redeliverWebhookDelivery(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedeliverWebhookDeliveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof redeliverWebhookDelivery>>
>;

export type RedeliverWebhookDeliveryMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Re-attempt a previous webhook delivery
 */
export const useRedeliverWebhookDelivery = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redeliverWebhookDelivery>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof redeliverWebhookDelivery>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRedeliverWebhookDeliveryMutationOptions(options));
};

/**
 * @summary List the current user's API keys (active + revoked)
 */
export const getListApiKeysUrl = () => {
  return `/api/api-keys`;
};

export const listApiKeys = async (
  options?: RequestInit,
): Promise<ApiKeyList> => {
  return customFetch<ApiKeyList>(getListApiKeysUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListApiKeysQueryKey = () => {
  return [`/api/api-keys`] as const;
};

export const getListApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof listApiKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listApiKeys>>> = ({
    signal,
  }) => listApiKeys({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListApiKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listApiKeys>>
>;
export type ListApiKeysQueryError = ErrorType<UnauthorizedResponse>;

/**
 * @summary List the current user's API keys (active + revoked)
 */

export function useListApiKeys<
  TData = Awaited<ReturnType<typeof listApiKeys>>,
  TError = ErrorType<UnauthorizedResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listApiKeys>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListApiKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Generates a fresh `mc_…` API key. The plaintext value is returned in the response body exactly once; the API never re-reveals it. Subsequent reads only expose the public prefix and the user's chosen label.

 * @summary Mint a new API key (plaintext returned exactly once)
 */
export const getCreateApiKeyUrl = () => {
  return `/api/api-keys`;
};

export const createApiKey = async (
  createApiKeyInput: CreateApiKeyInput,
  options?: RequestInit,
): Promise<CreateApiKeyResult> => {
  return customFetch<CreateApiKeyResult>(getCreateApiKeyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createApiKeyInput),
  });
};

export const getCreateApiKeyMutationOptions = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    { data: BodyType<CreateApiKeyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApiKey>>,
  TError,
  { data: BodyType<CreateApiKeyInput> },
  TContext
> => {
  const mutationKey = ["createApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApiKey>>,
    { data: BodyType<CreateApiKeyInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createApiKey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApiKey>>
>;
export type CreateApiKeyMutationBody = BodyType<CreateApiKeyInput>;
export type CreateApiKeyMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse
>;

/**
 * @summary Mint a new API key (plaintext returned exactly once)
 */
export const useCreateApiKey = <
  TError = ErrorType<BadRequestResponse | UnauthorizedResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiKey>>,
    TError,
    { data: BodyType<CreateApiKeyInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createApiKey>>,
  TError,
  { data: BodyType<CreateApiKeyInput> },
  TContext
> => {
  return useMutation(getCreateApiKeyMutationOptions(options));
};

/**
 * Soft-deletes the key by setting `revokedAt`. The row stays for the audit trail but the auth middleware refuses it on every subsequent request. Idempotent — revoking an already-revoked key is a no-op success.

 * @summary Revoke an API key
 */
export const getRevokeApiKeyUrl = (id: number) => {
  return `/api/api-keys/${id}/revoke`;
};

export const revokeApiKey = async (
  id: number,
  options?: RequestInit,
): Promise<ApiKeyEnvelope> => {
  return customFetch<ApiKeyEnvelope>(getRevokeApiKeyUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRevokeApiKeyMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeApiKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeApiKey>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeApiKey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeApiKey>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeApiKey(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeApiKey>>
>;

export type RevokeApiKeyMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | NotFoundResponse
>;

/**
 * @summary Revoke an API key
 */
export const useRevokeApiKey = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | NotFoundResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeApiKey>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeApiKey>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeApiKeyMutationOptions(options));
};
